//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft de inhoud van het Adviesbox-form 'Documenten downloaden' voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    documenten_downloaden_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<DocumentenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Documenten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumenten_downloaden_van_voorstel_ophalen(_response);
        });
    }

    protected processDocumenten_downloaden_van_voorstel_ophalen(response: Response): Promise<DocumentenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentenOutput>(null as any);
    }

    /**
     * Endpoint om een document van een rapport toe te voegen aan een advies
     * @param body (optional) 
     * @return OK
     */
    rapportdocument_toevoegen_voor_een_advies(vestigingId: string, adviesId: string, body: RapportDocumentInput | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Advies/{adviesId}/Rapporten";
        if (adviesId === undefined || adviesId === null)
            throw new Error("The parameter 'adviesId' must be defined.");
        url_ = url_.replace("{adviesId}", encodeURIComponent("" + adviesId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportdocument_toevoegen_voor_een_advies(_response);
        });
    }

    protected processRapportdocument_toevoegen_voor_een_advies(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Endpoint om de index van rapporten te tonen voor een specifiek advies
     * @return OK
     */
    index_van_rapporten_voor_een_specifiek_advies_ophalen(vestigingId: string, adviesId: string): Promise<RapportListOutput> {
        let url_ = this.baseUrl + "/Advies/{adviesId}/Rapporten";
        if (adviesId === undefined || adviesId === null)
            throw new Error("The parameter 'adviesId' must be defined.");
        url_ = url_.replace("{adviesId}", encodeURIComponent("" + adviesId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex_van_rapporten_voor_een_specifiek_advies_ophalen(_response);
        });
    }

    protected processIndex_van_rapporten_voor_een_specifiek_advies_ophalen(response: Response): Promise<RapportListOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportListOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportListOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportListOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportListOutput>(null as any);
    }

    /**
     * Download een specifiek rapport voor een gegeven advies
     * @param vestigingId De identificatie van de vestiging
     * @param adviesId De identificatie van het advies
     * @param rapportId de naam van het rapport
     * @return OK
     */
    download_een_specifiek_rapport_voor_een_gegeven_advies(vestigingId: string, adviesId: string, rapportId: string): Promise<void> {
        let url_ = this.baseUrl + "/Advies/{adviesId}/Rapporten/{rapportId}/Download";
        if (adviesId === undefined || adviesId === null)
            throw new Error("The parameter 'adviesId' must be defined.");
        url_ = url_.replace("{adviesId}", encodeURIComponent("" + adviesId));
        if (rapportId === undefined || rapportId === null)
            throw new Error("The parameter 'rapportId' must be defined.");
        url_ = url_.replace("{rapportId}", encodeURIComponent("" + rapportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownload_een_specifiek_rapport_voor_een_gegeven_advies(_response);
        });
    }

    protected processDownload_een_specifiek_rapport_voor_een_gegeven_advies(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportDownloadOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportDownloadOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Start het genereren van een financieringsopzet voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return Created
     */
    financieringsopzet_van_voorstel_genereren(vestigingId: string, voorstelId: string): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Financieringsopzet/Overzichten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinancieringsopzet_van_voorstel_genereren(_response);
        });
    }

    protected processFinancieringsopzet_van_voorstel_genereren(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * Start het genereren van een hypotheeklastenoverzicht voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return Created
     */
    hypotheeklastenoverzicht_van_voorstel_genereren(vestigingId: string, voorstelId: string): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Hypotheeklasten/Overzichten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklastenoverzicht_van_voorstel_genereren(_response);
        });
    }

    protected processHypotheeklastenoverzicht_van_voorstel_genereren(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * Start het genereren van een hypotheeklastenoverzicht voor de huidige situatie van het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return Created
     */
    hypotheeklastenoverzicht_van_huidige_situatie_genereren(vestigingId: string, adviesdossierId: string): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Hypotheeklasten/Overzichten";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHypotheeklastenoverzicht_van_huidige_situatie_genereren(_response);
        });
    }

    protected processHypotheeklastenoverzicht_van_huidige_situatie_genereren(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * Clean cache (tijdelijk)
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param voorstelId Identificatie van voorstel
     * @return OK
     */
    motivering_cache_legen(vestigingId: string, adviesdossierId: string, voorstelId: string): Promise<MotiveringOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Voorstellen/{voorstelId}/Motivering/Clean";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMotivering_cache_legen(_response);
        });
    }

    protected processMotivering_cache_legen(response: Response): Promise<MotiveringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotiveringOutput>(null as any);
    }

    /**
     * Geeft het motiverings overzicht terug als PDF
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderdeel Het soort gebeurtenis
     * @param klantId (optional) Laat bij overzicht voor beide het klantId leeg
     * @return OK
     */
    motivering_overzicht_ophalen(vestigingId: string, adviesdossierId: string, onderdeel: Onderdeel, klantId: string | null | undefined): Promise<MotiveringOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Motivering/{onderdeel}?";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        if (klantId !== undefined && klantId !== null)
            url_ += "klantId=" + encodeURIComponent("" + klantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMotivering_overzicht_ophalen(_response);
        });
    }

    protected processMotivering_overzicht_ophalen(response: Response): Promise<MotiveringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotiveringOutput>(null as any);
    }

    /**
     * Geeft het motiverings overzicht terug als PDF
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param onderdeel Het soort gebeurtenis
     * @param klantId (optional) Laat bij overzicht voor beide het klantId leeg
     * @return OK
     */
    motivering_overzicht_ophalen_voor_voorstel(vestigingId: string, voorstelId: string, onderdeel: Onderdeel2, klantId: string | null | undefined): Promise<MotiveringOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Motivering/{onderdeel}?";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        if (klantId !== undefined && klantId !== null)
            url_ += "klantId=" + encodeURIComponent("" + klantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMotivering_overzicht_ophalen_voor_voorstel(_response);
        });
    }

    protected processMotivering_overzicht_ophalen_voor_voorstel(response: Response): Promise<MotiveringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotiveringOutput>(null as any);
    }

    /**
     * Geeft het motiverings overzicht terug voor een adviesdossier (huidige situatie)
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param onderdeel Het soort gebeurtenis
     * @param klantId (optional) Laat bij overzicht voor beide het klantId leeg
     * @return OK
     */
    compleet_motivering_overzicht_ophalen_advies(vestigingId: string, adviesdossierId: string, onderdeel: Onderdeel3, klantId: string | null | undefined): Promise<MotiveringCompleetOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/Motivering/{onderdeel}/Compleet";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "klantId": klantId !== undefined && klantId !== null ? "" + klantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleet_motivering_overzicht_ophalen_advies(_response);
        });
    }

    protected processCompleet_motivering_overzicht_ophalen_advies(response: Response): Promise<MotiveringCompleetOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotiveringCompleetOutput>(null as any);
    }

    /**
     * Geeft het motiverings overzicht terug voor een voorstel
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het adviesdossier
     * @param onderdeel Het soort gebeurtenis
     * @param klantId (optional) Laat bij overzicht voor beide het klantId leeg
     * @return OK
     */
    compleet_motivering_overzicht_ophalen_voorstel(vestigingId: string, voorstelId: string, onderdeel: Onderdeel4, klantId: string | null | undefined): Promise<MotiveringCompleetOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Motivering/{onderdeel}/Compleet";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        if (onderdeel === undefined || onderdeel === null)
            throw new Error("The parameter 'onderdeel' must be defined.");
        url_ = url_.replace("{onderdeel}", encodeURIComponent("" + onderdeel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "klantId": klantId !== undefined && klantId !== null ? "" + klantId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleet_motivering_overzicht_ophalen_voorstel(_response);
        });
    }

    protected processCompleet_motivering_overzicht_ophalen_voorstel(response: Response): Promise<MotiveringCompleetOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MotiveringCompleetOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotiveringCompleetOutput>(null as any);
    }

    /**
     * Ophalen van een adviesdossier op basis van ID voor rapportage
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van de adviesdossier
     * @param includeVoorstellen (optional) 
     * @return OK
     */
    adviesdossier_ophalen_voor_rapportage(vestigingId: string, adviesdossierId: string, includeVoorstellen: boolean | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/adviesdossier/{adviesdossierId}/Rapportage?";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (includeVoorstellen !== undefined && includeVoorstellen !== null)
            url_ += "includeVoorstellen=" + encodeURIComponent("" + includeVoorstellen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviesdossier_ophalen_voor_rapportage(_response);
        });
    }

    protected processAdviesdossier_ophalen_voor_rapportage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Haalt de gegenereerde rapporthoofdstukken op
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId ID van het adviesdossier
     * @param rapportId ID van het rapport
     * @return OK
     */
    rapportage(vestigingId: string, adviesdossierId: string, rapportId: string): Promise<Rapport> {
        let url_ = this.baseUrl + "/adviesdossier/{adviesdossierId}/Rapportage/{rapportId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (rapportId === undefined || rapportId === null)
            throw new Error("The parameter 'rapportId' must be defined.");
        url_ = url_.replace("{rapportId}", encodeURIComponent("" + rapportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage(_response);
        });
    }

    protected processRapportage(response: Response): Promise<Rapport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Rapport;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Rapport>(null as any);
    }

    /**
     * Geeft alle basisgegevens / het gehele Klantprofiel terug.
     * @param vestigingId De identificatie van de vestiging
     * @return OK
     */
    klantprofiel_basis(vestigingId: string): Promise<KlantprofielOpzetOutput> {
        let url_ = this.baseUrl + "/Rapportage/Klantprofiel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKlantprofiel_basis(_response);
        });
    }

    protected processKlantprofiel_basis(response: Response): Promise<KlantprofielOpzetOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOpzetOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielOpzetOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KlantprofielOpzetOutput>(null as any);
    }

    /**
     * Haalt alle beschikbare replaceable tags op met beschrijvingen
     * @return OK
     */
    beschikbare_tags_voor_tekstEditor_met_metadata(): Promise<ReplaceableTagInfo[]> {
        let url_ = this.baseUrl + "/Rapportage/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBeschikbare_tags_voor_tekstEditor_met_metadata(_response);
        });
    }

    protected processBeschikbare_tags_voor_tekstEditor_met_metadata(response: Response): Promise<ReplaceableTagInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReplaceableTagInfo[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReplaceableTagInfo[]>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Rapport samenstellen voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    rapport_samenstellen_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<RapportSamenstellenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/RapportSamenstellen";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapport_samenstellen_van_adviesdossier_ophalen(_response);
        });
    }

    protected processRapport_samenstellen_van_adviesdossier_ophalen(response: Response): Promise<RapportSamenstellenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportSamenstellenOutput>(null as any);
    }

    /**
     * Geeft de rapportagestructuur met de gegeven ID voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param structuurId De identificatie van de rapportage-structuur
     * @return OK
     */
    rapportage_structuur_van_voorstel_ophalen(vestigingId: string, voorstelId: string, structuurId: string): Promise<RapportSamenstellenStructuurOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/RapportSamenstellen/Structuren/{structuurId}";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        if (structuurId === undefined || structuurId === null)
            throw new Error("The parameter 'structuurId' must be defined.");
        url_ = url_.replace("{structuurId}", encodeURIComponent("" + structuurId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_structuur_van_voorstel_ophalen(_response);
        });
    }

    protected processRapportage_structuur_van_voorstel_ophalen(response: Response): Promise<RapportSamenstellenStructuurOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportSamenstellenStructuurOutput>(null as any);
    }

    /**
     * Geeft de rapportagestructuur met de gegeven ID voor de huidige situatie het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param structuurId De identificatie van de rapportage-structuur
     * @return OK
     */
    rapportage_structuur_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string, structuurId: string): Promise<RapportSamenstellenStructuurOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/RapportSamenstellen/Structuren/{structuurId}";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (structuurId === undefined || structuurId === null)
            throw new Error("The parameter 'structuurId' must be defined.");
        url_ = url_.replace("{structuurId}", encodeURIComponent("" + structuurId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_structuur_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processRapportage_structuur_van_huidige_situatie_ophalen(response: Response): Promise<RapportSamenstellenStructuurOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenStructuurOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportSamenstellenStructuurOutput>(null as any);
    }

    /**
     * Genereert een rapport voor het gegeven voorstel met de gegeven rapportstructuur.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param body De rapportage-structuur
     * @return Created
     */
    rapport_van_voorstel_genereren(vestigingId: string, voorstelId: string, body: RapportSamenstellenStructuur): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/RapportSamenstellen/Rapporten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapport_van_voorstel_genereren(_response);
        });
    }

    protected processRapport_van_voorstel_genereren(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Genereert een rapport voor de huidige situatie van het gegeven adviesdossier met de gegeven rapportstructuur.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body De rapportage-structuur
     * @return Created
     */
    rapport_van_huidige_situatie_genereren(vestigingId: string, adviesdossierId: string, body: RapportSamenstellenStructuur): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/RapportSamenstellen/Rapporten";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapport_van_huidige_situatie_genereren(_response);
        });
    }

    protected processRapport_van_huidige_situatie_genereren(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft gegevens van het gegenereerde rapport met de gegeven ID, incl. een tijdelijke URL indien het volledig gegenereerd is.
     * @param vestigingId De identificatie van de vestiging
     * @param rapportId De identificatie van het rapport
     * @return OK
     */
    gegevens_van_rapport_ophalen(vestigingId: string, rapportId: string): Promise<RapportSamenstellenDataOutput> {
        let url_ = this.baseUrl + "/RapportSamenstellen/Rapporten/{rapportId}";
        if (rapportId === undefined || rapportId === null)
            throw new Error("The parameter 'rapportId' must be defined.");
        url_ = url_.replace("{rapportId}", encodeURIComponent("" + rapportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGegevens_van_rapport_ophalen(_response);
        });
    }

    protected processGegevens_van_rapport_ophalen(response: Response): Promise<RapportSamenstellenDataOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenDataOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenDataOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportSamenstellenDataOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportSamenstellenDataOutput>(null as any);
    }

    /**
     * Stopt het genereren van het rapport met het gegeven ID.
     * @param vestigingId De identificatie van de vestiging
     * @param rapportId De identificatie van het rapport
     * @return No Content
     */
    rapport_genereren_annuleren(vestigingId: string, rapportId: string): Promise<void> {
        let url_ = this.baseUrl + "/RapportSamenstellen/Rapporten/{rapportId}";
        if (rapportId === undefined || rapportId === null)
            throw new Error("The parameter 'rapportId' must be defined.");
        url_ = url_.replace("{rapportId}", encodeURIComponent("" + rapportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapport_genereren_annuleren(_response);
        });
    }

    protected processRapport_genereren_annuleren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Snel inzicht voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    snel_inzicht_van_adviesdossier_ophalen(vestigingId: string, adviesdossierId: string): Promise<SnelInzichtOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/SnelInzicht";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSnel_inzicht_van_adviesdossier_ophalen(_response);
        });
    }

    protected processSnel_inzicht_van_adviesdossier_ophalen(response: Response): Promise<SnelInzichtOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnelInzichtOutput>(null as any);
    }

    /**
     * Geeft het productoverzicht met de gegeven ID voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return OK
     */
    productoverzicht_van_voorstel_ophalen(vestigingId: string, voorstelId: string): Promise<SnelInzichtProductoverzichtenOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/SnelInzicht/Productoverzicht";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductoverzicht_van_voorstel_ophalen(_response);
        });
    }

    protected processProductoverzicht_van_voorstel_ophalen(response: Response): Promise<SnelInzichtProductoverzichtenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtProductoverzichtenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtProductoverzichtenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtProductoverzichtenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnelInzichtProductoverzichtenOutput>(null as any);
    }

    /**
     * Geeft het productoverzicht met de gegeven ID voor de huidige situatie van het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return OK
     */
    productoverzicht_van_huidige_situatie_ophalen(vestigingId: string, adviesdossierId: string): Promise<SnelInzichtProductoverzichtenOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/SnelInzicht/Productoverzicht";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductoverzicht_van_huidige_situatie_ophalen(_response);
        });
    }

    protected processProductoverzicht_van_huidige_situatie_ophalen(response: Response): Promise<SnelInzichtProductoverzichtenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtProductoverzichtenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtProductoverzichtenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SnelInzichtProductoverzichtenOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SnelInzichtProductoverzichtenOutput>(null as any);
    }

    /**
     * Start het genereren van een snel inzicht-overzicht voor het gegeven voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return Created
     */
    snel_inzichtOverzicht_van_voorstel_genereren(vestigingId: string, voorstelId: string): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/SnelInzicht/Overzichten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSnel_inzichtOverzicht_van_voorstel_genereren(_response);
        });
    }

    protected processSnel_inzichtOverzicht_van_voorstel_genereren(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * Start het genereren van een snel inzicht-overzicht voor de huidige situatie van het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @return Created
     */
    snel_inzichtOverzicht_van_huidige_situatie_genereren(vestigingId: string, adviesdossierId: string): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/SnelInzicht/Overzichten";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSnel_inzichtOverzicht_van_huidige_situatie_genereren(_response);
        });
    }

    protected processSnel_inzichtOverzicht_van_huidige_situatie_genereren(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * Start het genereren van een snel inzicht-overzicht voor een voorstel.
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @param alleenEersteJaar (optional) Indicatie dat alleen het eerste volledige jaar berekend moet worden
     * @return Created
     */
    lastenOverzicht_voor_een_voorstel_genereren(vestigingId: string, voorstelId: string, alleenEersteJaar: boolean | null | undefined): Promise<LastenOverzichtV2> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/SnelInzicht/LastenOverzicht?";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        if (alleenEersteJaar !== undefined && alleenEersteJaar !== null)
            url_ += "alleenEersteJaar=" + encodeURIComponent("" + alleenEersteJaar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLastenOverzicht_voor_een_voorstel_genereren(_response);
        });
    }

    protected processLastenOverzicht_voor_een_voorstel_genereren(response: Response): Promise<LastenOverzichtV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LastenOverzichtV2>(null as any);
    }

    /**
     * Start het genereren van een snel inzicht-overzicht voor de huidige situatie van het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param alleenEersteJaar (optional) Indicatie dat alleen het eerste volledige jaar berekend moet worden
     * @return Created
     */
    lastenOverzicht_van_huidige_situatie_genereren(vestigingId: string, adviesdossierId: string, alleenEersteJaar: boolean | null | undefined): Promise<LastenOverzichtV2> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/SnelInzicht/LastenOverzicht?";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        if (alleenEersteJaar !== undefined && alleenEersteJaar !== null)
            url_ += "alleenEersteJaar=" + encodeURIComponent("" + alleenEersteJaar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLastenOverzicht_van_huidige_situatie_genereren(_response);
        });
    }

    protected processLastenOverzicht_van_huidige_situatie_genereren(response: Response): Promise<LastenOverzichtV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenOverzichtV2;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LastenOverzichtV2>(null as any);
    }

    /**
     * Start het genereren van een verbouwingsspecificatie voor het gegeven voorstel
     * @param vestigingId De identificatie van de vestiging
     * @param voorstelId De identificatie van het voorstel
     * @return Created
     */
    verbouwingsspecificatie_van_het_voorstel_genereren(vestigingId: string, voorstelId: string): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Voorstellen/{voorstelId}/Verbouwingsspecificatie/Overzichten";
        if (voorstelId === undefined || voorstelId === null)
            throw new Error("The parameter 'voorstelId' must be defined.");
        url_ = url_.replace("{voorstelId}", encodeURIComponent("" + voorstelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerbouwingsspecificatie_van_het_voorstel_genereren(_response);
        });
    }

    protected processVerbouwingsspecificatie_van_het_voorstel_genereren(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * Start het genereren van een vergelijkend hypotheeklastenoverzicht voor het gegeven adviesdossier.
     * @param vestigingId De identificatie van de vestiging
     * @param adviesdossierId De identificatie van het adviesdossier
     * @param body (optional) Input voor het genereren van het overzicht
     * @return Created
     */
    vergelijkend_hypotheeklastenoverzicht_van_adviesdossier(vestigingId: string, adviesdossierId: string, body: VergelijkendHypotheeklastenInput | null | undefined): Promise<OverzichtSubscriptionOutput> {
        let url_ = this.baseUrl + "/Adviesdossiers/{adviesdossierId}/VergelijkendHypotheeklasten/Overzichten";
        if (adviesdossierId === undefined || adviesdossierId === null)
            throw new Error("The parameter 'adviesdossierId' must be defined.");
        url_ = url_.replace("{adviesdossierId}", encodeURIComponent("" + adviesdossierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVergelijkend_hypotheeklastenoverzicht_van_adviesdossier(_response);
        });
    }

    protected processVergelijkend_hypotheeklastenoverzicht_van_adviesdossier(response: Response): Promise<OverzichtSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverzichtSubscriptionOutput;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverzichtSubscriptionOutput>(null as any);
    }

    /**
     * @return OK
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return OK
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export interface AankoopkostenBestaandeBouw {
    koopsomRoerendeZaken: number | null;
    overdrachtsbelasting: number | null;
    makelaarscourtage: number | null;
    leveringsakte: number | null;
    verbouwingsKosten: number | null;
    koopsomWoning: number | null;
    kostenKoper: boolean | null;
    energieBespaarBudget: number | null;
    energieBesparendeVoorzieningen: number | null;
    afkoopsomErfpacht: number | null;
    totaalAankoopkosten: number;
    bankgarantiekosten: number | null;
}

export interface AankoopkostenNieuwbouw {
    grondprijs: number | null;
    meerwerk: number | null;
    bouwrenteVoorAankoop: number | null;
    bouwrenteNaAankoop: number | null;
    renteverlies: number | null;
    koopsomWoning: number | null;
    kostenKoper: boolean | null;
    energieBespaarBudget: number | null;
    energieBesparendeVoorzieningen: number | null;
    afkoopsomErfpacht: number | null;
    totaalAankoopkosten: number;
    bankgarantiekosten: number | null;
}

export interface AanleidingHoofdstuk {
    aanleidingenGesprek: string[] | null;
    financieleWensenEnDoelen: string[] | null;
    verwachtingenFinancieleToekomst: StringStringTuple[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface AcceptatieAanvrager {
    naam: string | null;
    geboortedatum: string | null;
    geslacht: string | null;
    brutoJaarInkomen: number | null;
    kredietToetslast: number | null;
}

export interface AcceptatieHoofdstuk {
    aanvrager1: AcceptatieAanvrager | null;
    aanvrager2: AcceptatieAanvrager | null;
    hypotheek: AcceptatieHypotheek | null;
    indicatie: AcceptatieIndicatie | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface AcceptatieHypotheek {
    marktwaardeBedrag: number | null;
    erfpachtBedrag: number | null;
    geldverstrekker: string | null;
    doorlopendeHypotheken: number | null;
    gewensteHypotheek: number | null;
    toetsrente: number | null;
    woonQuote: number | null;
    fictieveJaarlast: number | null;
    toegestaneJaarlast: number | null;
    maximaleHypotheekOpBasisVanInkomenEnLasten: number | null;
    maximaleHypotheekOpBasisVanOnderpandEnLening: number | null;
    maximaleHypotheekOpBasisVanNhgVoorwaarden: number | null;
    verplichteExtraAflossing: number | null;
    looptijdExtraAflossing: number | null;
    indicatieMeerMinderLenen: number | null;
}

export interface AcceptatieIndicatie {
    toelichtingRegels: string[] | null;
    voetnoten: string[] | null;
    indicatie: string | null;
}

export interface Adres {
    straat: string | null;
    huisnummer: number | null;
    toevoeging: string | null;
    postcode: string | null;
    plaats: string | null;
}

export interface Aflossing {
    jaar: number;
    aflossingsbedrag: number | null;
    nettoMaandlast: number | null;
    brutoMaandlast: number | null;
}

export interface AkkoordverklaringHoofdstuk {
    hasAanvrager2: boolean;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface Antwoord {
    antwoordId: number;
    omschrijving: string | null;
    deel1Datatype: AntwoordDatatypeOptions;
    deel2Datatype: AntwoordDatatypeOptions | null;
    deel3Datatype: AntwoordDatatypeOptions | null;
    toelichtingVerplichtBijJa: boolean;
    risicoprofielScoring: RisicoprofielScoring | null;
    omschrijvingWens: string | null;
    deel2AntwoordId: number | null;
    deel3AntwoordId: number | null;
}

/** AntwoordDatatypeOptions Aantal = 1, Percentage = 2, Bedrag = 3, Tekst = 4, JaNee = 5 */
export enum AntwoordDatatypeOptions {
    Aantal = "Aantal",
    Percentage = "Percentage",
    Bedrag = "Bedrag",
    Tekst = "Tekst",
    JaNee = "JaNee",
}

export interface AoVerzekering {
    product: string | null;
    ingangsdatum: string;
    eindDatum: string;
    ingangsdatumPremieBetaling: string;
    eindDatumPremieBetaling: string;
    isLopend: boolean;
    naamVerzekeraar: string | null;
    verzekerden: string | null;
    termijnPremie: number;
    termjn: string | null;
    polisNummer: string | null;
    dekkingen: Dekking[] | null;
    soortProduct: string | null;
    meenemen: boolean;
    uwBemiddeling: boolean | null;
    koopsom: number | null;
    indexatiePremie: any | null;
    premieAftrekbaarAo: boolean | null;
    collectief: boolean | null;
}

export interface AovHoofdstuk {
    verzekeringen: AoVerzekering[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface BadRequestResult {
    statusCode: number;
}

export interface BelangrijkeFinancieleGebeurtenissenHoofdstuk {
    gebeurtenissen: FinancieleGebeurtenis[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface Belastingteruggave {
    totaalFiscaalAftrekbareBedragen: number;
    eenmaligeExtraBelastingteruggave: number;
}

export interface BenodigdKapitaal {
    gebeurtenis: string | null;
    voorWie: string | null;
    omschrijving: string | null;
    bedrag: number;
}

/** BetalingsTermijnType Geen = 0, Maand = 1, TweeMaanden = 2, Kwartaal = 3, HalfJaar = 6, Jaar = 12, Eenmalig = 99, Week = -7, Dag = -1 */
export enum BetalingsTermijnType {
    Geen = "Geen",
    Maand = "Maand",
    TweeMaanden = "TweeMaanden",
    Kwartaal = "Kwartaal",
    HalfJaar = "HalfJaar",
    Jaar = "Jaar",
    Eenmalig = "Eenmalig",
    Week = "Week",
    Dag = "Dag",
}

export interface CappedAmount {
    value: number;
    isOk: boolean;
}

export interface Categorie {
    categorieId: number;
    omschrijving: string | null;
    onderwerpen: Onderwerp[] | null;
}

/** ControleGewenstInkomenOptions Nbi = 1, BrutoInkomenswens = 2, Geen = 3 */
export enum ControleGewenstInkomenOptions {
    Nbi = "Nbi",
    BrutoInkomenswens = "BrutoInkomenswens",
    Geen = "Geen",
}

/** ControleGewenstNbiOptions BehoudenHuidigNbi = 0, MargeHuidigNbi = 1, VastBedrag = 2, PercentageHuidigNbi = 3 */
export enum ControleGewenstNbiOptions {
    BehoudenHuidigNbi = "BehoudenHuidigNbi",
    MargeHuidigNbi = "MargeHuidigNbi",
    VastBedrag = "VastBedrag",
    PercentageHuidigNbi = "PercentageHuidigNbi",
}

/** ControleMaandlastOptions BenodigdInkomen = 1, WerkelijkeLast = 2 */
export enum ControleMaandlastOptions {
    BenodigdInkomen = "BenodigdInkomen",
    WerkelijkeLast = "WerkelijkeLast",
}

export interface Dashboard {
    werkloosheid: DashboardScenarioWerkloosheid | null;
    arbeidsongeschiktheid: DashboardScenarioArbeidsongeschiktheid | null;
    overlijden: DashboardScenarioOverlijden | null;
    pensioen: DashboardScenarioPensioen | null;
    aanvrager1: any | null;
    aanvrager2: any | null;
}

export interface DashboardScenarioArbeidsongeschiktheid {
    uitgangspunten: DashboardUitgangspuntenArbeidsongeschiktheid | null;
    tekort: DashboardTekort | null;
}

export interface DashboardScenarioOverlijden {
    uitgangspunten: DashboardUitgangspuntenOverlijden | null;
    tekort: DashboardTekort | null;
}

export interface DashboardScenarioPensioen {
    uitgangspunten: DashboardUitgangspuntenPensioen | null;
    tekort: DashboardTekort | null;
}

export interface DashboardScenarioWerkloosheid {
    uitgangspunten: DashboardUitgangspuntenWerkloosheid | null;
    tekort: DashboardTekort | null;
}

export interface DashboardTekort {
    tekortHypotheek1Bedrag: number | null;
    tekortHypotheek2Bedrag: number | null;
    tekortHypotheekBeideBedrag: number | null;
    tekortInkomen1Bedrag: number | null;
    tekortInkomen2Bedrag: number | null;
    tekortInkomenBeideBedrag: number | null;
}

export interface DashboardUitgangspuntenArbeidsongeschiktheid {
    scenarioVanKlantIds: string[] | null;
    overzichtBeideTonen: boolean;
    toetsjaar: number | null;
    scenarioDoorrekeningExtra1: boolean | null;
    scenarioDoorrekeningExtra2: boolean | null;
    arbeidsongeschiktheidStandaardPercentage: number | null;
    arbeidsongeschiktheidExtra1Percentage: number | null;
    arbeidsongeschiktheidExtra2Percentage: number | null;
    duurzaamArbeidsongeschiktStandaard: boolean | null;
    duurzaamArbeidsongeschiktExtra1: boolean | null;
    duurzaamArbeidsongeschiktExtra2: boolean | null;
    benuttingVerdiencapaciteitStandaardPercentage: number | null;
    benuttingVerdiencapaciteitExtra1Percentage: number | null;
    benuttingVerdiencapaciteitExtra2Percentage: number | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface DashboardUitgangspuntenOverlijden {
    scenarioVanKlantIds: string[] | null;
    overzichtBeideTonen: boolean;
    werkenNaOverlijdenPartnerAanvrager1Percentage: number | null;
    werkenNaOverlijdenPartnerAanvrager2Percentage: number | null;
    duurOverzicht: DuurOverzichtOptions | null;
    overzichtDuurInJaren: number | null;
    overzichtTotLeeftijdInMaanden: number | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface DashboardUitgangspuntenPensioen {
    scenarioVanKlantIds: string[] | null;
    overzichtBeideTonen: boolean;
    beschikbareJaarruimteAanvrager1: MotiveringBeschikbareJaarruimte | null;
    beschikbareJaarruimteAanvrager2: MotiveringBeschikbareJaarruimte | null;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface DashboardUitgangspuntenWerkloosheid {
    scenarioVanKlantIds: string[] | null;
    overzichtBeideTonen: boolean;
    controleHypotheeknorm: MotiveringControleHypotheeknorm | null;
    controleGewenstInkomen: MotiveringControleGewenstInkomen | null;
    readonly voorstellen: MotiveringVoorstel[] | null;
    motiveringVoorVoorstelId: string | null;
}

export interface DefaultHoofdstuk {
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface Dekking {
    naamDekking: string | null;
    verzekerdBedrag: number | null;
    verzekerdBedragVervolgjaren: number | null;
    eigenRisicoPeriode: string | null;
    beoordelingsCriterium: string | null;
    uitkeringBijAo: UitkeringAoSoort | null;
    beoordelingsCriteriaumVervolgjaren: string | null;
    uitkeringsdrempel: number | null;
    uitkeringsdrempelVervolgJaren: number | null;
    eindleeftijdUitkering: number | null;
    maxUitkeringsDuur: string | null;
    soortIndexatie: string | null;
    indexatiePercentage: number | null;
    waardeopbouwInPolis: string | null;
    eigenRisicoOmschrijving: string | null;
    premieBedrag: number | null;
    betalingsTermijn: string | null;
    maxUitkeringBedrag: number | null;
    aanvullingTot: string | null;
    aanvullingPerJaarMet: string | null;
    fiscaalAftrekbaar: number | null;
    eindDatumLeeftijdPartner: string | null;
    verzekerde: string | null;
    keuzeDekking: string | null;
    basisDekkingPercentage: number | null;
}

export interface DienstverleningHoofdstuk {
    adviesKostenTitel: StringStringKeyValuePair | null;
    adviesOnderwerpen: string[] | null;
    advieskosten: { [key: string]: number; } | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface DisclaimerHoofdstuk {
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface Documenten {
    financieringsopzetBeschikbaar: boolean;
    hypotheeklastenBeschikbaar: boolean;
    specificatieVerbouwingBeschikbaar: boolean;
}

export interface DocumentenOutput {
    documenten: { [key: string]: Documenten; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface DubbeleLastenDetails {
    ingangsdatum: string | null;
    bedrag: number | null;
    renteLeningdelen: number[] | null;
    brutoMaandlast: number | null;
    nettoMaandlast: number | null;
    overbruggingskredietBrutoMaandlast: number | null;
    overbruggingskredietNettoMaandlast: number | null;
    lastBeeindigd: number | null;
}

export interface DubbeleLastenOverbruggingDetails {
    totaleNettoMaandlasten: number | null;
    nieuweNettoMaandlasten: number | null;
    correctieDoorlopendeProducten: number | null;
    nettoLastenOverbrugging: number | null;
    extraMaandlastenTijdensOverbrugging: number | null;
    totaleKostenOverbrugging: number | null;
    aantalMaandenOverbrugging: number | null;
}

/** DuurOverzichtOptions TotLeeftijd = 1, VasteDuurInJaren = 2, Levenslang = 3 */
export enum DuurOverzichtOptions {
    TotLeeftijd = "TotLeeftijd",
    VasteDuurInJaren = "VasteDuurInJaren",
    Levenslang = "Levenslang",
}

/** DuurPensioenuitkeringOptions TotLeeftijd = 1, Levenslang = 3 */
export enum DuurPensioenuitkeringOptions {
    TotLeeftijd = "TotLeeftijd",
    Levenslang = "Levenslang",
}

export interface FinancieleGebeurtenis {
    datum: string;
    jaar: number;
    maand: number;
    omschrijving: string | null;
    leeftijdAanvrager: string | null;
    leeftijdPartner: string | null;
}

export interface FinancieringsOpzetData {
    aankoopkostenNieuwbouw: AankoopkostenNieuwbouw | null;
    aankoopkostenBestaandeBouw: AankoopkostenBestaandeBouw | null;
    kostenAndereFinancieringsvormen: KostenAndereFinancieringsvormen | null;
    financieringskosten: FinancieringsOpzetFinancieringskosten | null;
    overigekosten: Overigekosten | null;
    financieringsbehoefte: Financieringsbehoefte | null;
    financieringsoort: Financieringsoort | null;
    voetnoten: VoetnootOptions[] | null;
}

export interface FinancieringsOpzetFinancieringskosten {
    kostenHypotheek: number;
    arbeidskostenNotarisBedrag: number | null;
    kostenTaxatie: number;
    nhgKosten: number;
    advieskosten: number | null;
    bemiddelingskosten: number | null;
    overigebemiddelingsvergoeding: number | null;
    bereidstellingskosten: number | null;
    dossiervergoeding: number;
    afsluitkostenStarterslening: number | null;
    afsluitkostenOverbruggingskrediet: number | null;
    totaalFinancieringskosten: number;
    boeterente: number | null;
}

export interface Financieringsbehoefte {
    totaleFinancieringsbehoefte: number;
    inbrengEigenGeld: number | null;
    gewenstHypotheekbedrag: number;
    doorlopendeLeningdelen: number | null;
    inbrengEigenMiddelen: number | null;
    inbrengVerwachteOverwaarde: number | null;
    extraAflossing: number | null;
    kortlopendeLening: number | null;
    eigenGeldOverigOmschrijving1: string | null;
    eigenGeldOverigOmschrijving2: string | null;
    eigenGeldOverig1: number | null;
    eigenGeldOverig2: number | null;
    eigengeldInbrengBedrag: number | null;
    eigenGeldInbrengOverig1Omschrijving: string | null;
    eigenGeldInbrengOverig1Bedrag: number | null;
    overbruggingskrediet: number | null;
    familielening: number | null;
    sVnStarterslening: number | null;
    overigeFinanciering1Omschrijving: string | null;
    overigeFinanciering2Omschrijving: string | null;
    overigeFinanciering1: number | null;
    overigeFinanciering2: number | null;
    eigenwoningschuldBedrag: number | null;
    box3: number | null;
}

/** Financieringsoort Geen = 0, AankoopBestaandeBouw = 1, AankoopNieuwbouw = 2, Oversluiten = 3, Heropname = 4, _2eHypotheek = 5, _3eHypotheek = 6, _4eHypotheek = 7, Omzetting = 8, _1eHypotheek = 9 */
export enum Financieringsoort {
    Geen = "Geen",
    AankoopBestaandeBouw = "AankoopBestaandeBouw",
    AankoopNieuwbouw = "AankoopNieuwbouw",
    Oversluiten = "Oversluiten",
    Heropname = "Heropname",
    _2eHypotheek = "_2eHypotheek",
    _3eHypotheek = "_3eHypotheek",
    _4eHypotheek = "_4eHypotheek",
    Omzetting = "Omzetting",
    _1eHypotheek = "_1eHypotheek",
}

export interface FinancieringsopzetHoofdstuk {
    readonly soortPand: SoortPand[] | null;
    financieringsopzet: FinancieringsOpzetData | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface FiscaleAftrekData {
    typeFinanciering: string | null;
    ingangsdatumHuidig: string | null;
    ingangsdatumVoorstel: string | null;
    afTeLossenBestaandeHypotheekVoorstel: number | null;
    aankoopprijsVoorstel: number | null;
    benodigdeFinancieringVoorstel: number | null;
    hoogteHypotheekHuidig: number | null;
    hoogteHypotheekVoorstel: number | null;
    hoogteOverbruggingskredietVoorstel: number | null;
    kapitaalopbouwHuidig: number | null;
    kapitaalopbouwVoorstel: number | null;
    fiscaalAftrekbaarHuidig: number | null;
    fiscaalAftrekbaarVoorstel: number | null;
    verkoopprijsHuidig: number | null;
    gedeelteInBox3Huidig: number | null;
    gedeelteInBox3Voorstel: number | null;
    eigenWoningReserveBijVerkoopVoorstel: number | null;
}

export interface FiscaleAftrekFinancieringskosten {
    advieskosten: number | null;
    nhgKosten: number | null;
    hypotheekakte: number | null;
    arbeidskostenNotaris: number | null;
    bereidstellingskosten: number | null;
    taxatiekosten: number | null;
    totaal: number | null;
}

export interface FiscaleAftrekHoofdstuk {
    hypotheekBedragInBox1: HypotheekBedragInBox1 | null;
    belastingteruggave: Belastingteruggave | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface GebeurtenisRijData {
    jaar: number | null;
    hypotheekSchuld: number | null;
    fiscaalAftrekbaar: number | null;
    brutoMaandlast: number | null;
    nettoMaandlast: number | null;
    bijzonderheden: string | null;
}

export interface GebeurtenissenTabelData {
    titel: string | null;
    rijen: GebeurtenisRijData[] | null;
}

/** Gebeurtenissoort Geen = 0, Levend = 1, Dood = 2, Ao = 4, Ww = 8, Pensioen = 256 */
export enum Gebeurtenissoort {
    Geen = "Geen",
    Levend = "Levend",
    Dood = "Dood",
    Ao = "Ao",
    Ww = "Ww",
    Pensioen = "Pensioen",
}

/** GeslachtOpties Geen = 0, Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Geen = "Geen",
    Man = "Man",
    Vrouw = "Vrouw",
}

/** HoofdstukCodeOptions Onbekend = 0, Voorblad = 1, Inhoudsopgave = 2, Hoofdstukken = 3, Bijlagen = 4, Inleiding = 301, WensenEnDoelstellingen = 303, BenodigdeFinanciering = 304, OnsAdvies = 305, ToelichtingAdvies = 306, Akkoordverklaring = 307, SpecificatieVermogen = 402, SpecificatieBelastbaarInkomen = 403, ToelichtingHypotheekvormen = 404, ToelichtingPensioenBijlage = 405, ToelichtingSocialeVoorzieningen = 406, UitgereikteDocumenten = 407, OntvangenDocumenten = 408, UwKlantprofiel = 409, Wijzigingsverklaring = 410, Disclaimer = 411, HuidigeSituatie = 412, SpecificatieInkomenUitgaven = 499, Aanleiding = 30302, Dienstverlening = 30303, Financieringsopzet = 30402, Verbouwingsspecificatie = 30404, FiscaleAftrek = 30405, Overwaardespecificatie = 30407, GeadviseerdeProducten = 30506, NieuweLastenoverzicht = 30507, NettoBesteedbaarInkomen = 30508, LastenVergelijken = 30510, BelangrijkeFinancieleGebeurtenissen = 30511, ToelichtingAdviesAlgemeen = 30601, ToelichtingUwHypotheek = 30602, ToelichtingAdviesOverlijden = 30603, ToelichtingArbeidsongeschiktheid = 30604, ToelichtingWerkloosheid = 30605, ToelichtingPensioen = 30606, ToelichtingRisicoscenarios = 30609, ToelichtingAcceptatie = 30610, KlantprofielAlgemeen = 40901, KlantprofielHypotheekAlgemeen = 40902, KlantprofielHypotheekVerduurzaming = 40903, KlantprofielHypotheekVerantwoordewoonlasten = 40904, KlantprofielHypotheekInbrengeigengeld = 40905, KlantprofielHypotheekDubbeleWoonlasten = 40906, KlantprofielHypotheekFiscaleAftrek = 40907, KlantprofielHypotheekAflossingsvorm = 40908, KlantprofielHypotheekRentevastperiode = 40909, KlantprofielHypotheekGeldverstrekker = 40910, KlantprofielRisicosOverlijden = 40911, KlantprofielRisicosArbeidsongeschiktheid = 40912, KlantprofielRisicosWerkloosheid = 40913, KlantprofielRisicosPensioen = 40914, KlantprofielVermogenOpbouwDoelvermogen = 40915, KlantprofielVermogenRisicoprofiel = 40916, VoorstelHypotheek = 3050601, VoorstelLevensverzekering = 3050602, SpaarrekeningenBeleggingsdepot = 3050603, Arbeidsongeschiktheidsverzekeringen = 3050604, VoorstelOverlijdensrisicoverzekering = 3050605, Kredieten = 3050607, Lijfrentes = 3050608, VoorstelOverigeFinancielePosten = 3050609, ToelichtingVerduurzaming = 3060201, ToelichtingVerantwoordeWoonlasten = 3060202, ToelichtingFiscaleAftrek = 3060203, ToelichtingInbrengEigenGeld = 3060204, ToelichtingHypotheekOversluiten = 3060205, ToelichtingDubbeleWoonlasten = 3060206, ToelichtingAflosvorm = 3060207, ToelichtingRentevastPeriode = 3060208, ToelichtingGeldverstrekker = 3060209, OntwikkelingVanUwRenteAftrekTabel = 306020304, ToelichtingAdviesOverlijdenMotivering = 306030204, ToelichtingArbeidsongeschiktheidMotivering = 306040204, ToelichtingWerkloosheidMotivering = 306050204, ToelichtingPensioenMotivering = 306060304 */
export enum HoofdstukCodeOptions {
    Onbekend = "Onbekend",
    Voorblad = "Voorblad",
    Inhoudsopgave = "Inhoudsopgave",
    Hoofdstukken = "Hoofdstukken",
    Bijlagen = "Bijlagen",
    Inleiding = "Inleiding",
    WensenEnDoelstellingen = "WensenEnDoelstellingen",
    BenodigdeFinanciering = "BenodigdeFinanciering",
    OnsAdvies = "OnsAdvies",
    ToelichtingAdvies = "ToelichtingAdvies",
    Akkoordverklaring = "Akkoordverklaring",
    SpecificatieVermogen = "SpecificatieVermogen",
    SpecificatieBelastbaarInkomen = "SpecificatieBelastbaarInkomen",
    ToelichtingHypotheekvormen = "ToelichtingHypotheekvormen",
    ToelichtingPensioenBijlage = "ToelichtingPensioenBijlage",
    ToelichtingSocialeVoorzieningen = "ToelichtingSocialeVoorzieningen",
    UitgereikteDocumenten = "UitgereikteDocumenten",
    OntvangenDocumenten = "OntvangenDocumenten",
    UwKlantprofiel = "UwKlantprofiel",
    Wijzigingsverklaring = "Wijzigingsverklaring",
    Disclaimer = "Disclaimer",
    HuidigeSituatie = "HuidigeSituatie",
    SpecificatieInkomenUitgaven = "SpecificatieInkomenUitgaven",
    Aanleiding = "Aanleiding",
    Dienstverlening = "Dienstverlening",
    Financieringsopzet = "Financieringsopzet",
    Verbouwingsspecificatie = "Verbouwingsspecificatie",
    FiscaleAftrek = "FiscaleAftrek",
    Overwaardespecificatie = "Overwaardespecificatie",
    GeadviseerdeProducten = "GeadviseerdeProducten",
    NieuweLastenoverzicht = "NieuweLastenoverzicht",
    NettoBesteedbaarInkomen = "NettoBesteedbaarInkomen",
    LastenVergelijken = "LastenVergelijken",
    BelangrijkeFinancieleGebeurtenissen = "BelangrijkeFinancieleGebeurtenissen",
    ToelichtingAdviesAlgemeen = "ToelichtingAdviesAlgemeen",
    ToelichtingUwHypotheek = "ToelichtingUwHypotheek",
    ToelichtingAdviesOverlijden = "ToelichtingAdviesOverlijden",
    ToelichtingArbeidsongeschiktheid = "ToelichtingArbeidsongeschiktheid",
    ToelichtingWerkloosheid = "ToelichtingWerkloosheid",
    ToelichtingPensioen = "ToelichtingPensioen",
    ToelichtingRisicoscenarios = "ToelichtingRisicoscenarios",
    ToelichtingAcceptatie = "ToelichtingAcceptatie",
    KlantprofielAlgemeen = "KlantprofielAlgemeen",
    KlantprofielHypotheekAlgemeen = "KlantprofielHypotheekAlgemeen",
    KlantprofielHypotheekVerduurzaming = "KlantprofielHypotheekVerduurzaming",
    KlantprofielHypotheekVerantwoordewoonlasten = "KlantprofielHypotheekVerantwoordewoonlasten",
    KlantprofielHypotheekInbrengeigengeld = "KlantprofielHypotheekInbrengeigengeld",
    KlantprofielHypotheekDubbeleWoonlasten = "KlantprofielHypotheekDubbeleWoonlasten",
    KlantprofielHypotheekFiscaleAftrek = "KlantprofielHypotheekFiscaleAftrek",
    KlantprofielHypotheekAflossingsvorm = "KlantprofielHypotheekAflossingsvorm",
    KlantprofielHypotheekRentevastperiode = "KlantprofielHypotheekRentevastperiode",
    KlantprofielHypotheekGeldverstrekker = "KlantprofielHypotheekGeldverstrekker",
    KlantprofielRisicosOverlijden = "KlantprofielRisicosOverlijden",
    KlantprofielRisicosArbeidsongeschiktheid = "KlantprofielRisicosArbeidsongeschiktheid",
    KlantprofielRisicosWerkloosheid = "KlantprofielRisicosWerkloosheid",
    KlantprofielRisicosPensioen = "KlantprofielRisicosPensioen",
    KlantprofielVermogenOpbouwDoelvermogen = "KlantprofielVermogenOpbouwDoelvermogen",
    KlantprofielVermogenRisicoprofiel = "KlantprofielVermogenRisicoprofiel",
    VoorstelHypotheek = "VoorstelHypotheek",
    VoorstelLevensverzekering = "VoorstelLevensverzekering",
    SpaarrekeningenBeleggingsdepot = "SpaarrekeningenBeleggingsdepot",
    Arbeidsongeschiktheidsverzekeringen = "Arbeidsongeschiktheidsverzekeringen",
    VoorstelOverlijdensrisicoverzekering = "VoorstelOverlijdensrisicoverzekering",
    Kredieten = "Kredieten",
    Lijfrentes = "Lijfrentes",
    VoorstelOverigeFinancielePosten = "VoorstelOverigeFinancielePosten",
    ToelichtingVerduurzaming = "ToelichtingVerduurzaming",
    ToelichtingVerantwoordeWoonlasten = "ToelichtingVerantwoordeWoonlasten",
    ToelichtingFiscaleAftrek = "ToelichtingFiscaleAftrek",
    ToelichtingInbrengEigenGeld = "ToelichtingInbrengEigenGeld",
    ToelichtingHypotheekOversluiten = "ToelichtingHypotheekOversluiten",
    ToelichtingDubbeleWoonlasten = "ToelichtingDubbeleWoonlasten",
    ToelichtingAflosvorm = "ToelichtingAflosvorm",
    ToelichtingRentevastPeriode = "ToelichtingRentevastPeriode",
    ToelichtingGeldverstrekker = "ToelichtingGeldverstrekker",
    OntwikkelingVanUwRenteAftrekTabel = "OntwikkelingVanUwRenteAftrekTabel",
    ToelichtingAdviesOverlijdenMotivering = "ToelichtingAdviesOverlijdenMotivering",
    ToelichtingArbeidsongeschiktheidMotivering = "ToelichtingArbeidsongeschiktheidMotivering",
    ToelichtingWerkloosheidMotivering = "ToelichtingWerkloosheidMotivering",
    ToelichtingPensioenMotivering = "ToelichtingPensioenMotivering",
}

export interface HuidigeSituatieHoofdstuk {
    personalia: HuidigeSituatiePersonalia[] | null;
    inkomens: HuidigeSituatieInkomen | null;
    pensioenen: HuidigeSituatiePensioen[] | null;
    woonsituaties: HuidigeSituatieWoonsituatie[] | null;
    hypotheken: HuidigeSituatieHypotheek[] | null;
    aov: AoVerzekering[] | null;
    levensverzekeringen: Levensverzekering[] | null;
    overlijdensrisicoverzekeringen: OverlijdensRisicoVerzekering[] | null;
    kredieten: KredietInfo[] | null;
    overigeFinancieelPosten: OverigeFinancieelPost[] | null;
    uitkerendeLijfrentes: LijfrenteUitkeringInfo[] | null;
    vermogens: VermogensRekening[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface HuidigeSituatieHypotheek {
    titel: string | null;
    hypotheekOpWoning: string | null;
    geldverstrekker: string | null;
    geldnemers: string | null;
    hypotheekvorm: string | null;
    ingangsdatum: string | null;
    einddatum: string | null;
    looptijdInMaanden: number | null;
    oorspronkelijkeHoofdsom: number | null;
    restantHoofdsom: number | null;
    restantHoofdsomDatum: string | null;
    renteaftrekken: HuidigeSituatieHypotheekRenteaftrek[] | null;
    waarvanInBox3: number | null;
    rentevariant: string | null;
    rentevastperiode: string | null;
    rentevastperiodeEinddatum: string | null;
    rentepercentage: number | null;
    extraAflossingen: HuidigeSituatieHypotheekExtraAflossing[] | null;
}

export interface HuidigeSituatieHypotheekExtraAflossing {
    omschrijving: string | null;
    bedrag: number | null;
}

export interface HuidigeSituatieHypotheekRenteaftrek {
    waarvanInBox1: number | null;
    einddatum: string | null;
    omschrijving: string | null;
}

export interface HuidigeSituatieInkomen {
    inkomensLoondienst: HuidigeSituatieInkomenLoondienst[] | null;
    inkomensOnderneming: HuidigeSituatieInkomenOnderneming[] | null;
    inkomensOverig: HuidigeSituatieInkomenOverig[] | null;
    inkomensOverigBox1: HuidigeSituatieInkomenOverigBox1[] | null;
    inkomensOverigBox3: HuidigeSituatieInkomenOverigBox3[] | null;
}

export interface HuidigeSituatieInkomenLoondienst {
    inkomenVolgnummer: number;
    inkomensPerAanvrager: HuidigeSituatieInkomenLoondienstAanvrager[] | null;
}

export interface HuidigeSituatieInkomenLoondienstAanvrager {
    naam: string | null;
    brutoJaarsalaris: number | null;
    beroepsfunctie: string | null;
    buitenlandsInkomen: string | null;
    aantalUrenPerWeek: number | null;
    intentieverklaring: string | null;
    datumInDienst: string | null;
    inkomenMeegenomenTot: string | null;
    datumUitDienst: string | null;
    werkgeverNaam: string | null;
    werkgeverAdres: string | null;
    werkgeverPostcodePlaats: string | null;
    werkgeverLand: string | null;
}

export interface HuidigeSituatieInkomenOnderneming {
    inkomenVolgnummer: number;
    omschrijving: string | null;
    inkomensPerAanvrager: HuidigeSituatieInkomenOndernemingAanvrager[] | null;
}

export interface HuidigeSituatieInkomenOndernemingAanvrager {
    naam: string | null;
    klantVolgnummer: number;
    gemiddeldeInkomsten: number | null;
    inkomenMeegenomenTot: string | null;
}

export interface HuidigeSituatieInkomenOverig {
    omschrijving: string | null;
    inkomensBox1: HuidigeSituatieInkomenOverigBox1[] | null;
    inkomensBox3: HuidigeSituatieInkomenOverigBox3[] | null;
}

export interface HuidigeSituatieInkomenOverigBox1 {
    stelposten: HuidigeSituatieStelpost[] | null;
}

export interface HuidigeSituatieInkomenOverigBox3 {
    stelposten: HuidigeSituatieStelpost[] | null;
}

export interface HuidigeSituatiePensioen {
    titel: string | null;
    pensioenuitvoerder: string | null;
    deelnemer: string | null;
    soortPensioenregeling: string | null;
    opbouwPercentage: number | null;
    pensioengevendSalaris: number | null;
    franchise: number | null;
    pensioengrondslag: number | null;
    pensioenaangroeiBedrag: number | null;
    pensioenOverzichtDatum: string | null;
    bijdragePrePensioen: number | null;
    bijdrageOuderdomsPensioen: number | null;
    bijdrageVrijwillig: number | null;
    prePensioenBedrag: number | null;
    prePensioenIngangsdatum: string | null;
    prePensioenLeeftijd: string | null;
    ouderdomspensioenBedrag: number | null;
    ouderdomspensioenIngangsdatum: string | null;
    ouderdomspensioenLeeftijd: string | null;
    overbruggingsPensioen: number | null;
    nabestaandenPensioenVoor65: number | null;
    nabestaandenPensioenVoor65NaAow: number | null;
    nabestaandenPensioenNa65TotAow: number | null;
    nabestaandenPensioenNa65: number | null;
    wezenpensioenBedrag: number | null;
    wezenpensioenEindleeftijd: number | null;
    invaliditeitspensioenBedrag: number | null;
    isHuidigeWerkgever: boolean;
}

export interface HuidigeSituatiePersonalia {
    naam: string | null;
    straat: string | null;
    postcode: string | null;
    plaats: string | null;
    burgerlijkeStaat: string | null;
    geboortedatum: string | null;
    geslacht: string | null;
    telefoonnummerMobiel: string | null;
    emailadres: string | null;
}

export interface HuidigeSituatieStelpost {
    omschrijving: string | null;
    belastingbox: number;
    bedragenPerAanvrager: HuidigeSituatieStelpostAanvrager[] | null;
    inkomenMeegenomenTot: string | null;
}

export interface HuidigeSituatieStelpostAanvrager {
    naam: string | null;
    klantVolgnummer: number;
    bedrag: number | null;
    inkomenMeegenomenTot: string | null;
}

export interface HuidigeSituatieWoonsituatie {
    type: string | null;
    adres: string | null;
    bewoners: string | null;
    eigendomsverhouding: string | null;
    gebruikWoning: string | null;
    aardOnderpand: string | null;
    marktwaarde: number | null;
    wozWaarde: number | null;
    eigenwoningforfait: number | null;
    verkoopstatus: string | null;
    verkoopprijs: number | null;
    verkoopkosten: number | null;
    ontbindendeVoorwaardenTot: string | null;
    huurPerMaand: number | null;
    huurstijgingPerJaar: number | null;
    energieLabel: string | null;
    energieLabelEinddatum: string | null;
}

export interface HypotheekBedragInBox1 {
    investering: Investering | null;
    financieringskosten: FiscaleAftrekFinancieringskosten | null;
    totalen: HypotheekBedragTotaal | null;
    belastingteruggave: Belastingteruggave | null;
}

export interface HypotheekBedragTotaal {
    maximaalTeFinancierenInBox1: number;
    gewensteHypotheekInclAndereFinancieringen: number;
    hypotheekInBox1: number;
    waarvanNietAftrekbaarBox3: number;
}

export interface HypotheekvormData {
    marktwaarde: number | null;
    hypotheekschuld: number | null;
    schuldverhouding: number | null;
    rentepercentage: number | null;
    brutoMaandlast: number | null;
    nettoMaandlast: number | null;
}

export interface InbrengEigenGeldData {
    inbrengEigenGeld: number | null;
    inbrengEigenGeldRestschuld: number | null;
    inbrengEigenGeldOverwaarde: number | null;
    extraAflossing: number | null;
    eigenGeldOverig1: number | null;
    eigenGeldOverig2: number | null;
    eigenGeldOmschrijving1: string | null;
    eigenGeldOmschrijving2: string | null;
    inbrengOpgebouwdeWaarde: number | null;
    iowOmschrijving: string | null;
    eigenGeldInbrengOverig1: number | null;
    eigenGeldInbrengOverig1Omschrijving: string | null;
    eigenGeldInbrengRestschuld: number | null;
}

export interface Inkomensanalyse {
    startdatum: string;
    gebeurtenisdatum: string;
    toetsjaar: number;
    aanvrager1: InkomensanalyseAanvrager | null;
    aanvrager2: InkomensanalyseAanvrager | null;
    resultaten: InkomensanalyseResultaat[] | null;
    totaalHuidigBrutoJaarinkomenBedrag: number;
    huidigNbiBedrag: number | null;
    nbiOverzicht: InkomensanalyseNbiOverzicht | null;
    nbiOverzichten: { [key: string]: InkomensanalyseNbiOverzicht; } | null;
    grafiekData: InkomensanalyseGrafiekData | null;
}

export interface InkomensanalyseAanvrager {
    huidigBrutoJaarinkomenBedrag: number | null;
    pensioendatum: string | null;
    aantalMaandenWwUitkering: number | null;
    klantId: string;
    readonly achternaam: string | null;
    readonly voorvoegsel: string | null;
    readonly voorletters: string | null;
    readonly voornamen: string | null;
    geslacht: GeslachtOpties | null;
    readonly roker: boolean | null;
    readonly geboortedatum: string | null;
    readonly aowdatum: string | null;
}

export interface InkomensanalyseBijzonderheid {
    bijzonderheid: string | null;
}

/** InkomensanalyseConclusieOpties Passend = 1, Verantwoord = 2, Overschrijdt = 3 */
export enum InkomensanalyseConclusieOpties {
    Passend = "Passend",
    Verantwoord = "Verantwoord",
    Overschrijdt = "Overschrijdt",
}

export interface InkomensanalyseGrafiekData {
    jaren: InkomensanalyseGrafiekDataJaar[] | null;
}

export interface InkomensanalyseGrafiekDataJaar {
    jaar: number;
    normBedrag: number | null;
    inkomenBedrag: number | null;
}

export interface InkomensanalyseNbiOverzicht {
    jaren: InkomensanalyseNbiOverzichtJaar[] | null;
    voetnoot: InkomensanalyseVoetnoot | null;
}

export interface InkomensanalyseNbiOverzichtJaar {
    jaar: number;
    leeftijd1: number;
    leeftijd2: number | null;
    inkomenBedrag: number;
    uitgavenBedrag: number;
    nbiBedrag: number;
    gewenstNbiBedrag: number;
    tekortOverschotBedrag: number;
    bijzonderheden: InkomensanalyseBijzonderheid[] | null;
}

export interface InkomensanalyseResultaat {
    aanvrager1: InkomensanalyseResultaatAanvrager | null;
    aanvrager2: InkomensanalyseResultaatAanvrager | null;
    toetsrentePercentage: number | null;
    maximaleHypotheekBedrag: number | null;
    maximaleHypotheekWoonquoteBox1Percentage: number | null;
    maximaleHypotheekWoonquoteBox3Percentage: number | null;
    toegestaneLastBedrag: number | null;
    werkelijkeLastBedrag: number | null;
    werkelijkeLastKredietenBedrag: number | null;
    hypotheeksaldoBedrag: number | null;
    gewensteHypotheekBedrag: number | null;
    conclusie: InkomensanalyseConclusieOpties | null;
    minimaalBenodigdKapitaalBedrag: number | null;
    beschikbaarVermogenBedrag: number | null;
    opgebouwdVermogenAflossingBedrag: number | null;
    extraAflossingUitDekkingBedrag: number | null;
    benodigdInkomenBedrag: number | null;
    benodigdInkomenWoonquoteBox1Percentage: number | null;
    benodigdInkomenWoonquoteBox3Percentage: number | null;
    gewenstBrutoInkomenBedrag: number | null;
    tekortBenodigInkomenBedrag: number | null;
    tekortGewenstBrutoInkomenBedrag: number | null;
    tekortToegestaneLastBedrag: number | null;
    nbiBedrag: number | null;
    gewenstNbiBedrag: number | null;
    tekortNbiBedrag: number | null;
    tekortMaximaleHypotheekBedrag: number | null;
    tekortNettoInkomenBedrag: number | null;
    totaalBrutoInkomenBedrag: number;
    totaalBrutoInkomenGemiddeldBedrag: number;
    consumptiefBedrag: number;
}

export interface InkomensanalyseResultaatAanvrager {
    verhuurBedrag: number;
    verhuurBruteringBedrag: number | null;
    beleggingenBedrag: number;
    beleggingenBruteringBedrag: number | null;
    aanmerkelijkBelangBedrag: number;
    aanmerkelijkBelangBruteringBedrag: number | null;
    restInkomenBedrag: number | null;
    inkomstenOverigBedrag: number | null;
    inkomstenOverigBruteringBedrag: number | null;
    invaliditeitspensioenBedrag: number | null;
    woonlastenverzekeringBedrag: number | null;
    woonlastenverzekeringBruteringBedrag: number | null;
    wiaExcedentVerzekeringBedrag: number | null;
    wiaExcedentVerzekeringBruteringBedrag: number | null;
    wgaGatVerzekeringBedrag: number | null;
    wgaGatVerzekeringBruteringBedrag: number | null;
    arbeidsongeschiktheidsverzekeringBedrag: number | null;
    arbeidsongeschiktheidsverzekeringBruteringBedrag: number | null;
    bruteringPercentage: number | null;
    ivaUitkeringBedrag: number | null;
    wgaUitkeringBedrag: number | null;
    wwUitkeringBedrag: number | null;
    nabestaandenpensioenBedrag: number | null;
    anwUitkeringBedrag: number | null;
    anwHiaatVerzekeringBedrag: number | null;
    anwHiaatVerzekeringBruteringBedrag: number | null;
    wezenPensioenuitkeringBedrag: number | null;
    wezenPensioenUitwonendKind: boolean | null;
    nabestaandenrenteBedrag: number | null;
    nabestaandenrenteBruteringBedrag: number | null;
    aanvullingInkomenBedrag: number | null;
    aanvullingInkomenBruteringBedrag: number | null;
    aowUitkeringBedrag: number | null;
    expirerendeLijfrenteBedrag: number | null;
    expirerendeLijfrenteBruteringBedrag: number | null;
    werkgeverspensioenBedrag: number | null;
    nettoInkomstenBedrag: number | null;
    readonly totaalBrutoInkomenGemiddeldBedrag: number | null;
    readonly totaalBrutoInkomenBedrag: number | null;
}

export interface InkomensanalyseVoetnoot {
    voetnoot: string | null;
}

export interface Investering {
    koopsom: number | null;
    bouwrente: number | null;
    meerwerk: number | null;
    verbouwing: number | null;
    overdrachtsbelasting: number | null;
    makelaarscourtage: number | null;
    leveringsakte: number | null;
    kostenBankgarantieBedrag: number | null;
    totaal: number | null;
    eigenwoningreserve: number | null;
    doorlopendeLeningdelen: number | null;
}

export interface KlantprofielAlgemeenHoofdstuk {
    doelstelling: any[] | null;
    toekomstPerspectief: any[] | null;
    kennisEnErvaring: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekAflossingsvormHoofdstuk {
    hypotheekHypotheekvorm: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekAlgemeenHoofdstuk {
    hypotheekAlgemeen: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekDubbeleWoonlastenHoofdstuk {
    hypotheekDubbeleWoonlasten: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekEigenGeldHoofdstuk {
    hypotheekEigenGeld: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekFiscaleAftrekHoofdstuk {
    hypotheekFiscaal: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekGeldverstrekkerHoofdstuk {
    hypotheekGeldverstrekker: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekRentevastperiodeHoofdstuk {
    hypotheekRentevastperiode: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekVerantwoordeWoonlastenHoofdstuk {
    hypotheekVerantwoordeWoonlasten: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielHypotheekVerduurzamingHoofdstuk {
    hypotheekVerduurzaming: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielOpzetOutput {
    readonly vragen: Vraag[] | null;
    readonly antwoorden: Antwoord[] | null;
    readonly onderwerpen: Onderwerp[] | null;
    readonly categorieen: Categorie[] | null;
}

export interface KlantprofielRisicosArbeidsongeschiktheidHoofdstuk {
    risicosArbeidsongeschiktheid: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielRisicosOverlijdenHoofdstuk {
    risicosOverlijden: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielRisicosPensioenHoofdstuk {
    risicosPensioen: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielRisicosWerkloosheidHoofdstuk {
    risicosWerkloosheid: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielVermogenOpbouwDoelvermogenHoofdstuk {
    vermogensopbouwOpbouwDoelvermogen: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KlantprofielVermogenRisicoprofielHoofdstuk {
    vermogensopbouwRisicoprofiel: any[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KostenAndereFinancieringsvormen {
    afTeLossenBestaandeHypotheken: number | null;
    overdrachtsbelasting: number | null;
    leveringsakte: number | null;
    verbouwVerbeteringWoning: number | null;
    energieBespaarBudget: number | null;
    energieBesparendeVoorzieningen: number | null;
    afkoopErfpacht: number | null;
    vergoedingPartner: number | null;
    totaalKosten: number | null;
}

export interface KredietHoofdstuk {
    kredieten: KredietInfo[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface KredietInfo {
    polis: string | null;
    geldverstrekker: string | null;
    geldnemers: string | null;
    kredietvorm: string | null;
    ingangsdatum: string | null;
    einddatum: string | null;
    looptijdInMaanden: number | null;
    limiet: number | null;
    hoofdsom: number | null;
    box1: number | null;
    einddatumRenteaftrek: string | null;
    box3: number | null;
    jaarlijksKostenPercentage: number | null;
    maandlast: number | null;
    bestedingsdoel: string | null;
}

export interface Lasten {
    jaar: number;
    leeftijdAanvrager: number;
    leeftijdPartner: number | null;
    brutoInkomen: number | null;
    waardeopbouw: number | null;
    somHypotheken: number | null;
    rente: number | null;
    hypotheekAflossing: number | null;
    uitkeringKapitaalverzekeringen: number | null;
    verzekeringspremies: number | null;
    spaarEnBeleggingsdepots: number | null;
    opnameUitDepot: number | null;
    kredietlast: number | null;
    erfpachtlast: number | null;
    overigeUitgaven: number | null;
    huur: number | null;
    brutoLast: number | null;
    fiscaalVoordeel: number | null;
    vrh: number | null;
    nettoLast: number | null;
}

export interface LastenInSituatie {
    analyseVolgnummer: number | null;
    omschrijving: string | null;
    leningdelenDetails: LeningdeelDetail[] | null;
    lenindelenOverzicht: LeningdeelOverview[] | null;
    producten: LastenVergelekenProduct[] | null;
    jaarGegevens: Lasten[] | null;
    totalen: Totalen | null;
}

export interface LastenOverzichtLasten {
    jaren: number[] | null;
    nettoLasten: number[] | null;
    fiscaalVoordelen: number[] | null;
    fiscaalNadelen: number[] | null;
}

export interface LastenOverzichtV2 {
    voetnoten: string[] | null;
    grafieken: SituatieLasten | null;
    belangrijkeGebeurtenissen: { [key: string]: RapportFinancieleGebeurtenis; } | null;
    jaarGegevens: Lasten[] | null;
    totalen: Totalen | null;
}

export interface LastenVergelekenHoofdstuk {
    situatieLasten: LastenInSituatie[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface LastenVergelekenProduct {
    productNaam: string | null;
    maatschappijNaam: string | null;
    bedrag: number | null;
    rentePercentage: number | null;
    omschrijving: string | null;
    productType: ProductTypeOptions;
    waardeopbouwInPolis: boolean | null;
    risicoDekkingType: string | null;
    verzekeringDetails: string | null;
    doelkapitaalBedrag: number | null;
    rendementPercentage: number | null;
    kapitaalType: string | null;
    uitkeringsTermijn: number | null;
    einddatumUitkering: string | null;
    uitkeringsBedrag: number | null;
    verzekerdePersoon: string | null;
    dekkingsSoort: string | null;
}

export interface LeningdeelDetail {
    onderdeel: string | null;
    leningnummer: string | null;
    ingangsdatum: string | null;
    hypotheekvorm: string | null;
    hypotheekbedrag: number | null;
    gedeelteConsumptief: number | null;
    looptijd: string | null;
    rentepercentage: number | null;
    rentevastperiodeEinddatum: string | null;
    renteaftrekOver: number | null;
    einddatumRenteaftrek: string | null;
}

export interface LeningdeelOverview {
    geldverstrekker: string | null;
    totaleHypotheeksom: number | null;
    hypotheekinschrijving: number | null;
}

export interface Levensverzekering {
    lopendeOfNieuwePolis: string | null;
    verzekeraar: string | null;
    productnaam: string | null;
    ingangsdatum: string | null;
    einddatum: string | null;
    looptijd: string | null;
    verzekeringnemers: string[] | null;
    verzekerden: string[] | null;
    soortVerzekering: string | null;
    doelkapitaal: number | null;
    doelkapitaalRendement: number | null;
    voorbeeldkapitaal: number | null;
    voorbeeldkapitaalRendement: number | null;
    garantieKapitaal: number | null;
    garantieKapitaalRendement: number | null;
    aanvangsstoring: number;
    lagePremie: number | null;
    lagePremieTermijn: string | null;
    hogePremie: number | null;
    hogePremieTermijn: string | null;
    hoogLaagContructieEinddatum: string | null;
    hoogLaagContructieLooptijdInMaanden: number | null;
    premieAanvangNaMaanden: number | null;
    einddatumPremiebetaling: string | null;
    premieLooptijdInMaanden: number | null;
    polisValtFiscaalIn: string | null;
    ingebrachteWaarde: number | null;
    actueelSaldoPremiedepot: number | null;
    depotVergoeding: number | null;
    polisIsVerpandAanGeldverstrekker: boolean | null;
    uitkeringBedoeldVoorAflossing: boolean | null;
    lijfrenteclausule: boolean;
    verzekerde1Overlijdensrisicodekking: Overlijdensrisicodekking | null;
    verzekerde2Overlijdensrisicodekking: Overlijdensrisicodekking | null;
    waardeopbouwInPolis: string | null;
    partnerrenteAanvragerBedrag: number | null;
    partnerrentePartnerBedrag: number | null;
    partnerrenteAanvragerDuur: number | null;
    partnerrentePartnerDuur: number | null;
    lijfrenteBeschikbareKoopsom: number | null;
    lijfrenteBox: string | null;
    lijfrenteTarief: number | null;
    lijfrenteOvergangOp2eVerzekerde: string | null;
    lijfrenteDuur: string | null;
    lijfrenteEinddatumHoog: string | null;
    lijfrenteUitkeringHoog: number | null;
    lijfrenteUitkeringstermijn: string | null;
    lijfrenteEinddatum: string | null;
    lijfrenteEinddatumOmschrijving: string | null;
    lijfrenteUitkering: number | null;
    lijfrenteUitkeringOmschrijving: string | null;
}

/** LijfrenteSoort Lijfrente = 0, BancaireLijfrente = 1 */
export enum LijfrenteSoort {
    Lijfrente = "Lijfrente",
    BancaireLijfrente = "BancaireLijfrente",
}

export interface LijfrenteUitkeringHoofdstuk {
    lijfrenteUitkeringen: LijfrenteUitkeringInfo[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface LijfrenteUitkeringInfo {
    beschikbareKoopsom: number | null;
    box: string | null;
    lijfrenteTarief: number | null;
    heeftOvergangOpPartner: boolean;
    overgangOpPartner: string | null;
    duur: string | null;
    einddatumHoog: string | null;
    uitkeringHoog: number | null;
    uitkeringstermijn: BetalingsTermijnType | null;
    einddatum: string | null;
    einddatumOmschrijving: string | null;
    termijnuitkering: number | null;
    uitkeringOmschrijving: string | null;
    maatschappij: string | null;
    aanvangUitkeringDatum: string | null;
    contractant: string | null;
    nieuwePolis: boolean;
    rekeningnummer: string | null;
    contractanten: string | null;
    soortLijfrente: LijfrenteSoort;
    verzekerden: string | null;
    verzekeringnemers: string | null;
}

export interface MotiveringBeschikbareJaarruimte {
    gewensteDuurPensioenUitkering: DuurPensioenuitkeringOptions | null;
    pensioenuitkeringTotLeeftijdInMaanden: number | null;
    winstBedrag: number | null;
    winstBerekendBedrag: number;
    winstOvernemen: boolean;
    tegenwoordigeDienstbetrekkingBedrag: number | null;
    tegenwoordigeDienstbetrekkingBerekendBedrag: number;
    tegenwoordigeDienstbetrekkingOvernemen: boolean;
    vroegereDienstbetrekkingBedrag: number | null;
    vroegereDienstbetrekkingBerekendBedrag: number;
    vroegereDienstbetrekkingOvernemen: boolean;
    buitenlandseInkomstenBedrag: number | null;
    reisaftrekBedrag: number;
    overigeWerkzaamhedenBedrag: number | null;
    overigeWerkzaamhedenBerekendBedrag: number;
    overigeWerkzaamhedenOvernemen: boolean;
    periodiekeUitkeringenBedrag: number | null;
    premiegrondslagBedrag: number;
    franchiseBedrag: number;
    subtotaalFranchise1Bedrag: number;
    premiegrondslagPercentage: number;
    subtotaalFranchise2Bedrag: number;
    pensioenaangroeiBedrag: number | null;
    readonly pensioenaangroeiPercentage: number | null;
    subtotaalPensioenaangroeiBedrag: number;
    toevoegingOdrBedrag: number | null;
    subtotaalToevoegingOdrBedrag: number;
    jaarruimteBedrag: number;
    benutteJaarruimteBedrag: number;
    benutteJaarruimteBerekendBedrag: number;
    benutteJaarruimteOvernemen: boolean;
    beschikbareJaarruimteBedrag: number;
    maxPremieGrondslag: number;
}

export interface MotiveringCompleetOutput {
    gebeurtenissoort: Gebeurtenissoort;
    klantVolgnummer: number | null;
    klantNaamAanvrager: string | null;
    klantNaamPartner: string | null;
    toelichtingRegels: ToelichtingRegel[] | null;
    normGegevens: NormGegevens | null;
    gebruikteToetsrente: number | null;
    financieringslastpercentageBox1: number | null;
    financieringslastpercentageBox3: number | null;
    toetsjaar: number | null;
    beschikbareJaarruimte: number | null;
    gevuldeKolommen: NbiOverzichtGebeurtenisKolomOptions[] | null;
    nettoBesteedbaarInkomen: NbiResult[] | null;
    benodigdKapitaal: BenodigdKapitaal | null;
    totaalHuidigBrutoJaarinkomenBedrag: number;
    totaalBrutoInkomenBedrag: number;
    totaalBrutoInkomenGemiddeldBedrag: number;
    scenarioGegevens: ScenarioGegevens | null;
    motiveringInkomensanalyse: Inkomensanalyse | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface MotiveringControleGewenstInkomen {
    controleGewenstInkomen: ControleGewenstInkomenOptions | null;
    brutoInkomenswensPercentage: number | null;
    controleGewenstNbi: ControleGewenstNbiOptions | null;
    margeOndergrensPercentage: number | null;
    margeBovengrensPercentage: number | null;
    vastBedrag: number | null;
    huidigNbiPercentage: number | null;
    gewijzigdeJarenTonen: boolean;
    benodigdKapitaalTonen: boolean;
}

export interface MotiveringControleHypotheeknorm {
    controleMaandlast: ControleMaandlastOptions | null;
    controleerMaximaleHypotheek: boolean;
}

export interface MotiveringKeuze {
    wensen: string[] | null;
    advies: string | null;
    keuze: string | null;
}

/** MotiveringOnderdeelOptions Overlijden = 0, Arbeidsongeschiktheid = 1, Werkloosheid = 2, Pensioen = 3, VerantwoordeWoonlasten = 4, Aflossingsvorm = 5, Rentevastperiode = 6, FiscaleAftrek = 7, InbrengEigenGeld = 8, DubbeleWoonlasten = 9, OpbouwDoelvermogen = 10, Risicoprofiel = 11 */
export enum MotiveringOnderdeelOptions {
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
    Risicoprofiel = "Risicoprofiel",
}

export interface MotiveringOutput {
    resultaat: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface MotiveringVoorstel {
    voorstelId: string;
    readonly omschrijving: string | null;
    volgnummer: number;
}

/** NbiOverzichtGebeurtenisKolomOptions Jaar = 1, LeeftijdAanvrager = 2, LeeftijdPartner = 3, Inkomsten = 4, Uitgaven = 5, NettoBesteed = 6, GewenstNettoBesteed = 7, TekortOverschot = 8, Bijzonderheden = 9 */
export enum NbiOverzichtGebeurtenisKolomOptions {
    Jaar = "Jaar",
    LeeftijdAanvrager = "LeeftijdAanvrager",
    LeeftijdPartner = "LeeftijdPartner",
    Inkomsten = "Inkomsten",
    Uitgaven = "Uitgaven",
    NettoBesteed = "NettoBesteed",
    GewenstNettoBesteed = "GewenstNettoBesteed",
    TekortOverschot = "TekortOverschot",
    Bijzonderheden = "Bijzonderheden",
}

export interface NbiResult {
    jaar: number;
    leeftijdAanvrager: number;
    leeftijdPartner: number;
    inkomsten: number;
    uitgaven: number;
    nettoBesteed: number;
    gewenstNettoBesteed: number;
    tekortOverschot: number;
    bijzonderheden: string[] | null;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NieuweLastenOverzichtHoofdstuk {
    lastenOverzicht: LastenOverzichtV2 | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface NormGegevens {
    gewenstBrutoInkomenBedrag: number | null;
    tekortGewenstBrutoInkomenBedrag: number | null;
    benodigdInkomenBedrag: number | null;
    tekortBenodigInkomenBedrag: number | null;
    tekortNettoInkomenBedrag: number | null;
    toegestaneLastBedrag: number | null;
    werkelijkeLastKredietenBedrag: number | null;
    werkelijkeLastBedrag: number | null;
    maximaleHypotheekBedrag: number | null;
    hypotheeksaldoBedrag: number | null;
    tekortMaximaleHypotheekBedrag: number | null;
    opgebouwdVermogenAflossingBedrag: number | null;
    beschikbaarVermogenBedrag: number | null;
    toetsrentePercentage: number | null;
    benodigdInkomenWoonquoteBox1Percentage: number | null;
    maximaleHypotheekWoonquoteBox1Percentage: number | null;
    benodigdInkomenWoonquoteBox3Percentage: number | null;
    consumptiefBedrag: number | null;
    waardeWoning: number | null;
    maandlastSituatie: string | null;
}

export interface Onderwerp {
    onderwerpId: number;
    omschrijving: string | null;
    toelichtingId: number | null;
    categorieId: number;
    vragen: Vraag[] | null;
}

export interface OverigeFinancieelPost {
    lopendeOfNieuwePolis: string | null;
    omschrijving: string | null;
    behandelenAls: string | null;
    fiscaalBehandelenAls: string | null;
    ingangsdatum: string | null;
    einddatum: string | null;
    looptijd: string | null;
    betrekkingOp: string | null;
    bedrag: number | null;
    termijn: string | null;
}

export interface Overigekosten {
    gewenstConsumptief: number | null;
    overigeKosten1Omschrijving: string | null;
    overigeKosten1: number | null;
    overigeKosten2Omschrijving: string | null;
    overigeKosten2: number | null;
    overigeKosten3Omschrijving: string | null;
    overigeKosten3: number | null;
    royementskosten: number | null;
    bouwkundigeKeuring: number | null;
    totaleRestschuld: number | null;
    kostenOmzettenLeningdeel: number | null;
    inTeLossenKredieten: number | null;
    totaalOverigeKosten: number | null;
}

export interface OverlijdensRisicoDekking {
    soort: string | null;
    verzekerdKapitaalBedrag: number | null;
    verzekerdKapitaalTekst: string | null;
    dekkingDaaltTot: number | null;
    duurDalingInJaren: number | null;
    uitkeringstermijn: string | null;
    partnerRente: string | null;
}

export interface OverlijdensRisicoVerzekering {
    lopendeOfNieuwePolis: string | null;
    verzekeraar: string | null;
    polisnummer: string | null;
    ingangsdatum: string | null;
    einddatum: string | null;
    looptijdInMaanden: number;
    verzekeringnemers: string[] | null;
    verzekerden: string[] | null;
    polisIsVerpandAanGeldverstrekker: boolean;
    uitkeringBedoeldVoorAflossing: boolean;
    lijfrenteclausule: boolean;
    verzekerde1Overlijdensrisicodekking: OverlijdensRisicoDekking | null;
    verzekerde2Overlijdensrisicodekking: OverlijdensRisicoDekking | null;
    einddatumPremiebetaling: string | null;
    premieLooptijdInMaanden: number | null;
    waardeopbouwInPolis: boolean;
    verzekerde1PremievrijstellingAo: boolean | null;
    verzekerde2PremievrijstellingAo: boolean | null;
    lagePremie: number | null;
    lagePremieTermijn: string | null;
    hogePremie: number | null;
    hogePremieTermijn: string | null;
    hoogLaagContructieEinddatum: string | null;
    hoogLaagContructieLooptijdInMaanden: number | null;
}

export interface Overlijdensrisicodekking {
    soort: string | null;
    verzekerdKapitaalBedrag: number | null;
    verzekerdKapitaalTekst: string | null;
    annuiteitsPercentage: number | null;
    dekkingDaaltTot: number | null;
    duurDalingInJaren: number | null;
    partnerRente: number | null;
    maximaleDuurRente: number | null;
    directIngaandeRente: boolean | null;
    uitstelDatum: string | null;
    premievrijstellingBijAo: boolean | null;
}

export interface Overwaarde {
    verkoopprijs: number;
    verkoopkosten: number;
    percentageEigendom: number;
    nettoOpbrengst: number;
    restantSchuld: number;
    vervreemdingssaldo: number;
    restantSchuldBox3: number;
    totaalOverwaarde: number;
}

export interface OverzichtSubscription {
    overzichtId: string;
    readonly sasToken: string | null;
}

export interface OverzichtSubscriptionOutput {
    subscription: OverzichtSubscription | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Paragraaf {
    paragraafNaam: string | null;
    inhoud: string | null;
    code: number;
}

export interface ProductInfo {
    productId: string;
    productsoort: SoortProductOptions;
    readonly productnaam: string | null;
    readonly maatschappijNaam: string | null;
    readonly omschrijving: string | null;
}

/** ProductTypeOptions Overbrugging = 0, Dekking = 1, Krediet = 2, VrijeKolom = 3 */
export enum ProductTypeOptions {
    Overbrugging = "Overbrugging",
    Dekking = "Dekking",
    Krediet = "Krediet",
    VrijeKolom = "VrijeKolom",
}

export interface Rapport {
    rapportId: string;
    rapportNaam: string | null;
    rapportStructuurNaam: string | null;
    rapportLogo: string | null;
    rapportFooter: string | null;
    naamAanvrager: string | null;
    naamPartner: string | null;
    voorblad: VoorbladHoofdstuk | null;
    inhoudsopgaveTonen: boolean;
    inleiding: DefaultHoofdstuk | null;
    huidigeSituatie: HuidigeSituatieHoofdstuk | null;
    toelichtingOverlijden: ToelichtingOverlijdenHoofdstuk | null;
    toelichtingHypotheekGeldverstrekker: ToelichtingHypotheekGeldverstrekkerHoofdstuk | null;
    toelichtingHypotheekDubbeleLasten: ToelichtingHypotheekDubbeleLastenHoofdstuk | null;
    uwBenodigdeFinanciering: DefaultHoofdstuk | null;
    onsAdvies: DefaultHoofdstuk | null;
    geadviseerdeProducten: DefaultHoofdstuk | null;
    hypotheek: VoorstelHypotheekHoofdstuk | null;
    levensverzekering: VoorstelLevensverzekeringHoofdstuk | null;
    overlijdensrisicoverzekering: VoorstelOverlijdensrisicoverzekeringHoofdstuk | null;
    overigeFinancielePosten: VoorstelOverigeFinancielePostenHoofdstuk | null;
    wensenEnDoelstellingenHoofdstuk: DefaultHoofdstuk | null;
    aanleidingHoofdstuk: AanleidingHoofdstuk | null;
    dienstverleningHoofdstuk: DienstverleningHoofdstuk | null;
    toelichtingHypotheekvormen: ToelichtingHypotheekvormenHoofdstuk | null;
    financieringsopzet: FinancieringsopzetHoofdstuk | null;
    aovHoofdstuk: AovHoofdstuk | null;
    verbouwingsspecificatie: VerbouwingsSpecificatieHoofdstuk | null;
    fiscaleAftrek: FiscaleAftrekHoofdstuk | null;
    specificatieOverwaarde: SpecificatieOverwaardeHoofstuk | null;
    akkoordverklaring: AkkoordverklaringHoofdstuk | null;
    acceptatie: AcceptatieHoofdstuk | null;
    belangrijkeFinancieleGebeurtenissen: BelangrijkeFinancieleGebeurtenissenHoofdstuk | null;
    toelichtingPensioen: ToelichtingPensioenHoofdstuk | null;
    toelichtingSocialeVoorzieningen: ToelichtingSocialeVoorzieningenHoofdstuk | null;
    disclaimer: DisclaimerHoofdstuk | null;
    nieuweLastenOverzicht: NieuweLastenOverzichtHoofdstuk | null;
    kredietenHoofdstuk: KredietHoofdstuk | null;
    lijfrentes: LijfrenteUitkeringHoofdstuk | null;
    spaarrekeningenHoofdstuk: SpaarrekeningenHoofdstuk | null;
    toelichtingAdvies: DefaultHoofdstuk | null;
    toelichtingAdviesAlgemeenHoofdstuk: ToelichtingAdviesAlgemeenHoofdstuk | null;
    toelichtingUwHypotheek: DefaultHoofdstuk | null;
    toelichtingVerduurzamingHoofdstuk: ToelichtingVerduurzamingHoofdstuk | null;
    toelichtingVerantwoordeWoonlastenHoofdstuk: ToelichtingVerantwoordeWoonlastenHoofdstuk | null;
    toelichtingFiscaleAftrekHoofdstuk: ToelichtingFiscaleAftrekHoofdstuk | null;
    toelichtingHypotheekvormHoofdstuk: ToelichtingHypotheekvormHoofdstuk | null;
    toelichtingRisicoscenarios: ToelichtingRisicoscenariosHoofdstuk | null;
    toelichtingHypotheekRentevastperiodeHoofdstuk: ToelichtingHypotheekRentevastperiodeHoofdstuk | null;
    toelichtingArbeidsongeschiktheid: ToelichtingArbeidsongeschiktheidHoofdstuk | null;
    klantprofielHypotheekAlgemeen: KlantprofielHypotheekAlgemeenHoofdstuk | null;
    lastenVergeleken: LastenVergelekenHoofdstuk | null;
    klantProfiel: DefaultHoofdstuk | null;
    klantProfielAlgemeen: KlantprofielAlgemeenHoofdstuk | null;
    toelichtingWerkloosheid: ToelichtingWerkloosheidHoofdstuk | null;
    toelichtingInbrengEigenGeld: ToelichtingInbrengEigenGeldHoofdstuk | null;
    klantprofielRisicosPensioen: KlantprofielRisicosPensioenHoofdstuk | null;
    klantprofielRisicosOverlijden: KlantprofielRisicosOverlijdenHoofdstuk | null;
    klantprofielRisicosWerkloosheid: KlantprofielRisicosWerkloosheidHoofdstuk | null;
    klantprofielRisicosArbeidsongeschiktheid: KlantprofielRisicosArbeidsongeschiktheidHoofdstuk | null;
    klantprofielVermogenRisicoprofiel: KlantprofielVermogenRisicoprofielHoofdstuk | null;
    klantprofielVermogenOpbouwDoelvermogen: KlantprofielVermogenOpbouwDoelvermogenHoofdstuk | null;
    klantprofielHypotheekVerduurzaming: KlantprofielHypotheekVerduurzamingHoofdstuk | null;
    klantprofielHypotheekVerantwoordeWoonlasten: KlantprofielHypotheekVerantwoordeWoonlastenHoofdstuk | null;
    klantprofielHypotheekRentevastperiode: KlantprofielHypotheekRentevastperiodeHoofdstuk | null;
    klantprofielHypotheekGeldverstrekker: KlantprofielHypotheekGeldverstrekkerHoofdstuk | null;
    klantprofielHypotheekFiscaleAftrek: KlantprofielHypotheekFiscaleAftrekHoofdstuk | null;
    klantprofielHypotheekEigenGeld: KlantprofielHypotheekEigenGeldHoofdstuk | null;
    klantprofielHypotheekDubbeleWoonlasten: KlantprofielHypotheekDubbeleWoonlastenHoofdstuk | null;
    klantprofielHypotheekAflossingsvorm: KlantprofielHypotheekAflossingsvormHoofdstuk | null;
}

export interface RapportDocumentInput {
    rapportId: string;
    rapportNaam: string | null;
    rapportageStructuurId: string;
}

export interface RapportDownloadOutput {
    bestandsnaam: string | null;
    mimeType: string | null;
    fileContent: string | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RapportFinancieleGebeurtenis {
    datum: string;
    jaar: number;
    readonly maand: string | null;
    omschrijving: string | null;
    leeftijdAanvrager: string | null;
    leeftijdPartner: string | null;
}

export interface RapportListOutput {
    rapporten: RapportOutput[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RapportOutput {
    rapportId: string;
    omschrijving: string | null;
    type: string | null;
    aanmaakdatum: string | null;
}

export interface RapportSamenstellen {
    voorstellen: RapportSamenstellenVoorstel[] | null;
    structuurKeuzes: RapportSamenstellenStructuurKeuze[] | null;
}

export interface RapportSamenstellenData {
    url: string | null;
    status: StatusGenererenRapportOptions;
}

export interface RapportSamenstellenDataOutput {
    rapportData: RapportSamenstellenData | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RapportSamenstellenElement {
    code: number;
    naam: string | null;
    geselecteerd: boolean;
    soortElement: SoortElementOptions;
    volgnummer: number;
    inhoud: string | null;
    elementen: RapportSamenstellenElement[] | null;
}

export interface RapportSamenstellenOutput {
    rapportenSamenstellen: { [key: string]: RapportSamenstellen; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RapportSamenstellenStructuur {
    elementen: RapportSamenstellenElement[];
    structuurId: string;
    volgnummer: number;
    naam: string | null;
}

export interface RapportSamenstellenStructuurKeuze {
    structuurId: string;
    volgnummer: number;
    naam: string | null;
}

export interface RapportSamenstellenStructuurOutput {
    structuur: RapportSamenstellenStructuur | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RapportSamenstellenVoorstel {
    voorstelId: string;
    volgnummer: number;
    omschrijving: string | null;
}

export interface RenteaftrekData {
    soort: string | null;
    aanvangsdatum: string | null;
    einddatum: string | null;
    bedrag: number;
    verloop: string | null;
}

export interface RenteaftrekkenTabelData {
    titel: string | null;
    rijen: RenteaftrekData[] | null;
}

export interface RentevastperiodeDataV2 {
    omschrijving: string | null;
    bedragRentewijziging1: number | null;
    bedragHuidigeRente: number | null;
    bedragRentewijziging2: number | null;
    bedragRentewijziging3: number | null;
    bedragRentewijziging4: number | null;
}

export interface ReplaceableTagInfo {
    tag: string | null;
    description: string | null;
}

/** RisicoprofielOptions ZeerDefensief = 1, Defensief = 2, Neutraal = 3, Offensief = 4, ZeerOffensief = 5 */
export enum RisicoprofielOptions {
    ZeerDefensief = "ZeerDefensief",
    Defensief = "Defensief",
    Neutraal = "Neutraal",
    Offensief = "Offensief",
    ZeerOffensief = "ZeerOffensief",
}

export interface RisicoprofielScoring {
    soortScore: SoortScoreOptions;
    score: number;
    maxRisicoprofiel: RisicoprofielOptions | null;
}

export interface Risicoscenario {
    titel: string | null;
    brutoInkomen: number;
    tekort: number;
    inkomensverlies: number;
}

export interface ScenarioGegevens {
    verdiencapaciteitPercentage: number | null;
    verdiencapaciteitPercentageExtra1: number | null;
    verdiencapaciteitPercentageExtra2: number | null;
    percentageArbeidsongeschiktheid: number | null;
    percentageArbeidsongeschiktheidExtra1: number | null;
    percentageArbeidsongeschiktheidExtra2: number | null;
    werkenNaOverlijdenPartnerPercentage: number | null;
}

export interface SituatieLasten {
    huidigeSituatie: LastenOverzichtLasten | null;
    nieuweSituatie: LastenOverzichtLasten | null;
}

export interface SnelInzicht {
    voorstellen: SnelInzichtVoorstel[] | null;
}

export interface SnelInzichtOutput {
    snelInzichten: { [key: string]: SnelInzicht; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface SnelInzichtProductoverzicht {
    producten: ProductInfo[] | null;
}

export interface SnelInzichtProductoverzichtenOutput {
    productoverzicht: { [key: string]: SnelInzichtProductoverzicht; } | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface SnelInzichtVoorstel {
    voorstelId: string;
    volgnummer: number;
    omschrijving: string | null;
}

/** SoortElementOptions Onderdeel = 1, Hoofdstuk = 2, Koptekst = 3, Tekstblok = 4, Grafiek = 5, Tabel = 6, Iteratie = 7, GegenereerdeTekst = 8 */
export enum SoortElementOptions {
    Onderdeel = "Onderdeel",
    Hoofdstuk = "Hoofdstuk",
    Koptekst = "Koptekst",
    Tekstblok = "Tekstblok",
    Grafiek = "Grafiek",
    Tabel = "Tabel",
    Iteratie = "Iteratie",
    GegenereerdeTekst = "GegenereerdeTekst",
}

export interface SoortPand {
    soortOnderpand: string | null;
    marktwaarde: number | null;
    marktwaardeNaVerbouwing: number | null;
    wozWaarde: number | null;
    adres: Adres | null;
    bouwjaar: number | null;
    energielabel: string | null;
}

/** SoortProductOptions Onbekend = 0, Hypotheek = 1, Kapitaalverzekering = 2, Overlijdensrisicoverzekering = 3, Woonlastenverzekering = 4, Vermogensrekening = 5, Krediet = 6, Lijfrente = 8, Overig = 9 */
export enum SoortProductOptions {
    Onbekend = "Onbekend",
    Hypotheek = "Hypotheek",
    Kapitaalverzekering = "Kapitaalverzekering",
    Overlijdensrisicoverzekering = "Overlijdensrisicoverzekering",
    Woonlastenverzekering = "Woonlastenverzekering",
    Vermogensrekening = "Vermogensrekening",
    Krediet = "Krediet",
    Lijfrente = "Lijfrente",
    Overig = "Overig",
}

/** SoortScoreOptions FinancieleSituatie = 1, Kennis = 2, Risicobereidheid = 3 */
export enum SoortScoreOptions {
    FinancieleSituatie = "FinancieleSituatie",
    Kennis = "Kennis",
    Risicobereidheid = "Risicobereidheid",
}

export interface SpaarrekeningenHoofdstuk {
    spaarrekeningen: VermogensRekening[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface SpecificatieOverwaardeHoofstuk {
    overwaarde: Overwaarde[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

/** StatusGenererenRapportOptions Gestart = 1, Klaar = 2, Geannuleerd = 3, Fout = 4, RapportV2 = 5 */
export enum StatusGenererenRapportOptions {
    Gestart = "Gestart",
    Klaar = "Klaar",
    Geannuleerd = "Geannuleerd",
    Fout = "Fout",
    RapportV2 = "RapportV2",
}

export interface StringStringKeyValuePair {
    key: string | null;
    value: string | null;
}

export interface StringStringTuple {
    item1: string | null;
    item2: string | null;
}

export interface ToelichtingAdviesAlgemeenHoofdstuk {
    financiering: string | null;
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingArbeidsongeschiktheidHoofdstuk {
    motivering: MotiveringCompleetOutput[] | null;
    dashboard: Dashboard | null;
    motiveringKeuzesAanvrager1: MotiveringKeuze | null;
    motiveringKeuzesAanvrager2: MotiveringKeuze | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingFiscaleAftrekHoofdstuk {
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    fiscaleAftrekData: FiscaleAftrekData | null;
    gebeurtenissenTabelData: GebeurtenissenTabelData | null;
    renteaftrekkenTabelData: RenteaftrekkenTabelData | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingHypotheekDubbeleLastenHoofdstuk {
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    huidigeSituatie: DubbeleLastenDetails | null;
    nieuweSituatie: DubbeleLastenDetails | null;
    overbrugging: DubbeleLastenOverbruggingDetails | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingHypotheekGeldverstrekkerHoofdstuk {
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingHypotheekRentevastperiodeHoofdstuk {
    afwijkendeKeuze: string | null;
    onsAdvies: string | null;
    wens1: string[] | null;
    wens2: string[] | null;
    rentevastperiodeData: RentevastperiodeDataV2[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingHypotheekvormHoofdstuk {
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    bijzonderheden: string | null;
    hypotheekaflossing: { [key: string]: HypotheekvormData; } | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingHypotheekvormenHoofdstuk {
    toelichtingHypotheekvormen: ToelichtingHypotheekvormenOutput | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingHypotheekvormenOutput {
    aflossingenAnnuiteitenHypotheek: Aflossing[] | null;
    aflossingenLineaireHypotheek: Aflossing[] | null;
}

export interface ToelichtingInbrengEigenGeldHoofdstuk {
    wensen: string[] | null;
    adviesen: string[] | null;
    keuzes: string[] | null;
    inbrengEigenGeld: InbrengEigenGeldData | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

/** ToelichtingOptions Brutering = 0, Verdiencapaciteit1 = 1, Verdiencapaciteit2 = 2, Verdiencapaciteit3 = 3, BrutoNettoTekort = 4, Wezenpensioen = 5, ExtraAflossingen = 6, OrvUitkering = 7, ToetsrenteFinancieringslast = 8, Hypotheeknorm = 9, WoonlastenVerzekering = 10, AoOngevallendekking = 11, OverlijdenMaximaleHypotheek = 12 */
export enum ToelichtingOptions {
    Brutering = "Brutering",
    Verdiencapaciteit1 = "Verdiencapaciteit1",
    Verdiencapaciteit2 = "Verdiencapaciteit2",
    Verdiencapaciteit3 = "Verdiencapaciteit3",
    BrutoNettoTekort = "BrutoNettoTekort",
    Wezenpensioen = "Wezenpensioen",
    ExtraAflossingen = "ExtraAflossingen",
    OrvUitkering = "OrvUitkering",
    ToetsrenteFinancieringslast = "ToetsrenteFinancieringslast",
    Hypotheeknorm = "Hypotheeknorm",
    WoonlastenVerzekering = "WoonlastenVerzekering",
    AoOngevallendekking = "AoOngevallendekking",
    OverlijdenMaximaleHypotheek = "OverlijdenMaximaleHypotheek",
}

export interface ToelichtingOverlijdenHoofdstuk {
    motivering: MotiveringCompleetOutput[] | null;
    dashboard: Dashboard | null;
    motiveringKeuzesAanvrager1: MotiveringKeuze | null;
    motiveringKeuzesAanvrager2: MotiveringKeuze | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingPensioenHoofdstuk {
    motivering: MotiveringCompleetOutput[] | null;
    dashboard: Dashboard | null;
    motiveringKeuzesAanvrager1: MotiveringKeuze | null;
    motiveringKeuzesAanvrager2: MotiveringKeuze | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingRegel {
    toelichting: string | null;
    type: ToelichtingOptions;
}

export interface ToelichtingRisicoscenariosHoofdstuk {
    risicoscenarios: Risicoscenario[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingSocialeVoorzieningenHoofdstuk {
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingVerantwoordeWoonlastenHoofdstuk {
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    bijzonderheden: string | null;
    normJaar: number;
    verantwoordeWoonlastenScenarios: VerantwoordeWoonlasten[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingVerduurzamingHoofdstuk {
    wens: string[] | null;
    advies: string | null;
    keuze: string | null;
    bijzonderheden: string | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface ToelichtingWerkloosheidHoofdstuk {
    motivering: MotiveringCompleetOutput[] | null;
    dashboard: Dashboard | null;
    motiveringKeuzesAanvrager1: MotiveringKeuze | null;
    motiveringKeuzesAanvrager2: MotiveringKeuze | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface Totalen {
    brutoInkomen: number | null;
    waardeopbouw: number | null;
    somHypotheken: number | null;
    rente: number | null;
    hypotheekAflossing: number | null;
    uitkeringKapitaalverzekeringen: number | null;
    verzekeringspremies: number | null;
    spaarEnBeleggingsdepots: number | null;
    opnameUitDepot: number | null;
    kredietlast: number | null;
    erfpachtlast: number | null;
    overigeUitgaven: number | null;
    huur: number | null;
    brutoLast: number | null;
    fiscaalVoordeel: number | null;
    vrh: number | null;
    nettoLast: number | null;
}

/** UitkeringAoSoort Geen = 0, Volledig = 1, ProRata = 2 */
export enum UitkeringAoSoort {
    Geen = "Geen",
    Volledig = "Volledig",
    ProRata = "ProRata",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VerantwoordeWoonlasten {
    scenario: string | null;
    brutoInkomen: number;
    brutoInkomenPerMaand: number;
    affordabilityRatio: number;
    geadviseerdeHypotheek: number | null;
    maximaleHypotheekInkomen: CappedAmount | null;
    maximaleHypotheekWoningwaarde: CappedAmount | null;
    gewensteHypotheek: number | null;
    maandlastNieuweSituatie: number | null;
    maximaleVerstrekkingNhg: number | null;
    maximaleWoonlast: CappedAmount | null;
    werkelijkeBrutomaandlast: CappedAmount | null;
    isVerantwoord: boolean;
    toelichting: string | null;
    fictieveMaandlast: number | null;
}

export interface Verbouwing {
    omschrijving: string | null;
    bedrag: number;
}

export interface VerbouwingsSpecificatieHoofdstuk {
    verbouwingen: Verbouwing[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface VergelijkendHypotheeklastenInput {
    voorstellen: VergelijkendHypotheeklastenVoorstel[] | null;
    huidigeSituatie: boolean;
}

export interface VergelijkendHypotheeklastenVoorstel {
    voorstelId: string | null;
}

export interface VermogensRekening {
    soortProduct: string | null;
    polis: string | null;
    instelling: string | null;
    productnaam: string | null;
    contractanten: string | null;
    ingangsdatum: string | null;
    box: string | null;
    doelrendement: number | null;
    voorbeeldrendement: number | null;
    doelkapitaal: number | null;
    aanvangsstorting: number | null;
    storting: number | null;
    stortingstermijn: string | null;
    rekeningnummer: string | null;
    einddatum: string | null;
    kapitaalopbouwObv: string | null;
    verpand: string | null;
    aflossing: string | null;
    lijfrenteclausule: string | null;
    looptijdInMaanden: number | null;
    aankoopkostenPercentage: number | null;
    verkoopkostenPercentage: number | null;
    beheerskostenPercentage: number | null;
    actueleWaarde: number | null;
    actueleWaardeDatumOverzicht: string | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

/** VoetnootOptions Geen = 0, Aftrekbaar = 1, Notaristarieven = 2, Afsluitkosten = 3, EnergiebesparendeVoorzieningen = 4, InbrengRestschuld = 5, BrutoLast = 6, BlokHypotheek = 7, FiscaalJaar = 8, OverigeUitgaven = 9, StartersCombinatieLening = 10 */
export enum VoetnootOptions {
    Geen = "Geen",
    Aftrekbaar = "Aftrekbaar",
    Notaristarieven = "Notaristarieven",
    Afsluitkosten = "Afsluitkosten",
    EnergiebesparendeVoorzieningen = "EnergiebesparendeVoorzieningen",
    InbrengRestschuld = "InbrengRestschuld",
    BrutoLast = "BrutoLast",
    BlokHypotheek = "BlokHypotheek",
    FiscaalJaar = "FiscaalJaar",
    OverigeUitgaven = "OverigeUitgaven",
    StartersCombinatieLening = "StartersCombinatieLening",
}

export interface VoorbladHoofdstuk {
    persoon1Naam: string | null;
    persoon2Naam: string | null;
    adviseurNaam: string | null;
    kantoorNaam: string | null;
    kantoorTelefoonnummer: string | null;
    kantoorEmail: string | null;
    adviesnummer: string | null;
    fotoBase64: string | null;
    aanmaakDatum: string | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface VoorstelHypotheekHoofdstuk {
    hasHypotheekInVoorstel: boolean;
    leningdelenOverview: LeningdeelOverview[] | null;
    leningdelenDetails: LeningdeelDetail[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface VoorstelLevensverzekeringHoofdstuk {
    levensverzekeringen: Levensverzekering[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface VoorstelOverigeFinancielePostenHoofdstuk {
    overigeFinancielePosten: OverigeFinancieelPost[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface VoorstelOverlijdensrisicoverzekeringHoofdstuk {
    overlijdensRisicoVerzekeringen: OverlijdensRisicoVerzekering[] | null;
    code: HoofdstukCodeOptions;
    titel: string | null;
    paragrafen: { [key: string]: Paragraaf; } | null;
    tabellen: { [key: string]: string; } | null;
}

export interface Vraag {
    vraagId: number;
    omschrijving: string | null;
    klantVolgNr: number | null;
    multipleChoice: boolean;
    vervolgOpAntwoordId1: number | null;
    vervolgOpAntwoordId2: number | null;
    isWensBijMotivering: boolean;
    antwoorden: Antwoord[] | null;
}

/** Het soort gebeurtenis */
export enum Onderdeel {
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
    Risicoprofiel = "Risicoprofiel",
}

/** Het soort gebeurtenis */
export enum Onderdeel2 {
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
    Risicoprofiel = "Risicoprofiel",
}

/** Het soort gebeurtenis */
export enum Onderdeel3 {
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
    Risicoprofiel = "Risicoprofiel",
}

/** Het soort gebeurtenis */
export enum Onderdeel4 {
    Overlijden = "Overlijden",
    Arbeidsongeschiktheid = "Arbeidsongeschiktheid",
    Werkloosheid = "Werkloosheid",
    Pensioen = "Pensioen",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Aflossingsvorm = "Aflossingsvorm",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    OpbouwDoelvermogen = "OpbouwDoelvermogen",
    Risicoprofiel = "Risicoprofiel",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}